import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { NoFilesIcon, ProgressBar, DelIcon } from "@/assets/AiBotAssets";
import Lottie from "react-lottie";
import animationData from "../../.././assets/LottiFiles/UploadSource.json";
import {
  AscendingOrderSvg,
  CharacterLimitIcon,
  CharactersIconSvg,
  DelIconSvg,
  DescendingOrderSVG,
  DownArrIconSvg,
  IErrIconSvg,
  LinkRejectedIcon,
  ReSyncingFailedIcon,
  ReSyncingIcon,
  RetrainBtnIcon,
  SourceLinkCloseIcon,
  TickMarkSvg,
  TrainingCompletedIcon,
  TrainingProgressIcon,
  ViewDetailsIcon,
  YoutubeIcon,
} from "./AiBotAssets";
import { axiosGet, axiosPost } from "@/services/axiosService";
import { userSlice } from "@/redux/User";
import { State } from "@/redux/Types";
import { useDispatch, useSelector } from "react-redux";
import ThreeDot from "@/components/loaders/ThreeDot";
import { BotContext } from "../store";
import RemoveConfirmation from "./RemoveConfirmation";
import useStore from "@/pages/omni-builder/store";
import { ConfigId } from "@/constants/ConfigData";
import useDebounce from "@/hooks/useDebounce";
import { useQueryClient } from "@tanstack/react-query";
import useGooglePickerConfig from "@/pages/omni-builder/react-query/configs/useGooglePickerConfig";
import useNotionConfig from "@/pages/omni-builder/react-query/configs/useNotionConfig";
import useConfluenceConfig from "@/pages/omni-builder/react-query/configs/useConfluenceConfig";
import useSalesForceConfig from "@/pages/omni-builder/react-query/configs/useSalesForceConfig";
import moment from "moment";
import {
  ConfluenceIcon,
  DocDeleteIcon,
  EditAppIcon,
  GoogleDriveIcon,
  NotionIcon,
  SalesforceIcon,
} from "./AiBotAssets";
import _ from "lodash";
import { AnimatePresence, motion } from "framer-motion";
import SmallLoader from "@/components/loaders/SmallLoader";
import VoiceCoachBanner from "@/components/layoutElements/VoiceCoachBanner";
import Pagination from "../Pagination";
import ViewDetailsModal from "./ViewDetailsModal";
import ModalWrapper from "./ModalWrapper";
import { useQuery } from "@tanstack/react-query";
import { createPortal } from "react-dom";
import Skeleton from "react-loading-skeleton";
import AllTrainedFiles from "./AllTrainedFiles";
import MostAskedQuestions from "@/pages/analytics/MostAskedQuestions";
import AllQuestionsModal from "@/pages/analytics/AllQuestions";
import TextAreaComponent from "./TextAreaComponent";
import { useNavigate } from "react-router-dom";
import useFormatNumber from "@/hooks/UseFormatNumber";
import NativeApps from "./dataSource/NativeApps";
import BooleanModal from "@/components/builder/BooleanModal";
import { debounce } from "lodash";
import { sendEventToOutgrow } from "@/pages/cbb-builder/outgrow-event.service";

// const TEXT_AREA_LIMIT = 1001;

interface dropdowns {
  linkStatus: boolean;
  fileStatus: boolean;
  fileAction: boolean;
  syncTime: boolean;
  linkCharacters: boolean;
  linkLastSynced: boolean;
  linkAutoSync: boolean;
  trainedappsAction: boolean;
  untrainedappsAction: boolean;
  appsAutoSync: boolean;
}
const dropdownState = {
  linkStatus: false,
  fileStatus: false,
  fileAction: false,
  syncTime: false,
  linkCharacters: false,
  linkLastSynced: false,
  linkAutoSync: false,
  trainedappsAction: false,
  untrainedappsAction: false,
  appsAutoSync: false,
};
function AIBotTab_1({
  onReload,
  botData,
  onDataChange,
  files,
  trainedFiles,
  onFileUpload,
  openGooglePicker,
  onFileRemove,
  fetchUrl,
  showProgress,
  uploadProgress,
  parentForceReload,
  websiteUrl,
  setWebsiteUrl,
  fetchLoader,
  fileLoader,
  setFetchModal,
  setDeleteModal,
  selectedSourceTab,
  setSelectedSetupTab,
  setSelectedSourceTab,
  setExtraUrl,
  extraUrl,
  fetchExtraUrl,
  iscrawling,
  showAddLink,
  setShowAddLink,
  error,
  setError,
  retryRejectedLinks,
  isRetraining,
  showPreview,
  characterLimit,
  characterUsed,
  processingDocuments,
  setProcessingDocuments,
  markDocumentsAsDeleting,
  markDocumentsAsDeleted,
  clearDeletionTracking,
  refetchCompany,
  isOld,
  stopPolling,
}) {
  console.log("isOld ::", isOld);
  const urls = botData.aiSource?.urls || [];
  const youtube = botData.aiSource?.youtube || [];
  const file = botData.aiSource?.documents || [];
  let searchData = botData.searchLinkHistory || [];
  const navigate = useNavigate();
  const itemsPerPage = 10;
  const rejectedLinks = useMemo(
    () => [
      ...(Array.isArray(urls)
        ? urls.filter((link) => link.status === "Link Rejected")
        : []),
      ...(Array.isArray(youtube)
        ? youtube.filter((link) => link.status === "Link Rejected")
        : []),
    ],
    [urls, youtube],
  );

  const isUrlTrainingRateLimited = useMemo(
    () => (urls ?? []).some((data) => data.status === "Limit Reached"),
    [urls],
  );

  const isFileTrainingRateLimited = useMemo(
    () => (file ?? []).some((data) => data.status === "Limit Reached"),
    [file],
  );

  const showTrainCancelBtnUrl = useMemo(
    () => (urls ?? []).some((data) => data.status === "In Progress"),
    [urls],
  );

  const rejectedFiles = useMemo(
    () => [
      ...(Array.isArray(file)
        ? file.filter((file) => file.status === "File Rejected")
        : []),
    ],
    [file],
  );

  const combinedUrls = [...youtube, ...urls];

  const isTrainingInProgress = useMemo(
    () =>
      iscrawling || combinedUrls.some((link) => link.status === "In Progress"),
    [iscrawling, combinedUrls],
  );

  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const plan: any = useSelector((state: State) => state.user.plan);
  const fromOutgrow = useSelector((state: State) => state.user.fromOutgrow);
  const size = plan?.ai_currentLimits?.fileSize
    ? (plan.ai_currentLimits.fileSize / (1024 * 1024)).toFixed(2)
    : 0;

  const [store, storeDispatch] = useContext(BotContext);
  const [buyAddOn, setBuyAddOn] = useState(false);

  const [dropdowns, setDropdowns] = useState<dropdowns>(dropdownState);
  const dropdownRef = useRef<any>({});
  const focusRef = useRef<HTMLInputElement>(null);
  const [selectedStatus, setSelectedStatus] = useState<{
    icon: React.ReactNode;
    text: string;
  }>({
    icon: null,
    text: "",
  });
  const [selectedFileStatus, setSelectedFileStatus] = useState<{
    icon: React.ReactNode;
    text: string;
  }>({
    icon: null,
    text: "",
  });

  const [selectedSync, setSelectedSync] = useState("");
  const [appSelectedSync, setAppSelectedSync] = useState({});
  const [fileSearchQuery, setFileSearchQuery] = useState("");
  const [syncTimes, setSyncTimes] = useState({});
  const [isStopped, setIsStopped] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [addLink, setAddLink] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [fileCurrentPage, setFileCurrentPage] = useState(1);
  const [searchedLinks, setSearchedLinks] = useState<any[]>([]);
  const [paginatedLinks, setPaginatedLinks] = useState<any[]>([]);
  const [searchedFiles, setSearchedFiles] = useState(trainedFiles || []);
  const [paginatedFiles, setPaginatedFiles] = useState(trainedFiles || []);
  const [drpToggle, setDrpToggle] = useState<dropdowns>(dropdownState);
  const [checkedState, setCheckedState] = useState({});
  const [dataToBeSaved, setDataToBeSaved] = useState<any>([]);
  const [resyncData, setResyncData] = useState<any>([]);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [selectedAll, setSelectedAll] = useState(false);
  const [isRecyncing, setIsRecyncing] = useState({});
  const [sortOrder, setSortOrder] = useState<"asc" | "desc" | null>(null);
  const [sortSyncOrder, setSortSyncOrder] = useState<"asc" | "desc" | null>(
    null,
  );
  const [activeSort, setActiveSort] = useState<string | null>(null);
  const [leaveModal, setLeaveModal] = useState(false);
  const applySort = useCallback((links: any[], sortType: string | null) => {
    const sortedLinks = [...links];

    switch (sortType) {
      case "char_asc":
        sortedLinks.sort(
          (a, b) => (a.characterCount || 0) - (b.characterCount || 0),
        );
        break;
      case "char_desc":
        sortedLinks.sort(
          (a, b) => (b.characterCount || 0) - (a.characterCount || 0),
        );
        break;
      case "sync_asc":
        sortedLinks.sort(
          (a, b) => Number(a.lastSyncTime) - Number(b.lastSyncTime),
        );
        break;
      case "sync_desc":
        sortedLinks.sort(
          (a, b) => Number(b.lastSyncTime) - Number(a.lastSyncTime),
        );
        break;
      default:
        // No sort applied, just return them in their original order
        break;
    }
    return sortedLinks;
  }, []);

  const [isPostTrainingDelay, setIsPostTrainingDelay] = useState(false);

  const [removeData, setRemoveData] = useState({
    status: false,
    remove: () => {},
  });
  const [isAllChecked, setIsAllChecked] = useState(false);

  const [inProcess, setInProcess] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const trainedSource = store.botData.aiSource;
  const dataSources = store.botData.dataSources;
  const [viewDetailsModal, setViewDetailsModal] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState<string>("");
  const [selectedContent, setSelectedContent] = useState([]);
  const [viewDetailsLoading, setViewDetailsLoading] = useState(false);
  const [urlDeleteLoading, setUrlDeleteLoading] = useState<
    Record<string, boolean>
  >({});

  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
    maxHeight: 0,
  });
  const [trainingCancelLoader, setTrainingCancelLoader] = useState(false);

  // Custom query hook for fetching trained content
  const fetchTrainedContent = async ({ sourceName, botCustomId }) => {
    const response = await axiosPost("/ai/fetch-trained-content", {
      sourceName,
      botCustomId,
    });
    return response.data.data;
  };
  // Create a query with enabled: false to control when it fetches
  const {
    data: trainedContentData,
    refetch: fetchTrainedContentQuery,
    isLoading: trainedContentLoading,
  } = useQuery({
    queryKey: ["trainedContent", botData.botCustomId, selectedUrl],
    queryFn: () =>
      fetchTrainedContent({
        sourceName: selectedUrl,
        botCustomId: botData.botCustomId,
      }),
    enabled: false, // Don't run automatically
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes (was cacheTime in v3)
  });

  // Update selected content whenever trainedContentData changes
  useEffect(() => {
    if (trainedContentData) {
      if (trainedContentData.content) {
        setSelectedContent(trainedContentData.content);
      }
    }
  }, [trainedContentData]);

  const handleViewDetails = async (
    url: string,
    status: string,
    content: string,
    index: number,
    type: "url" | "file" = "url",
  ) => {
    try {
      if (status === "In Progress") return;
      setViewDetailsLoading(true);
      setViewDetailsModal(true);
      setSelectedUrl(url);

      // Get the cached query key
      const queryKey = ["trainedContent", botData.botCustomId, url];

      // Check if data exists in cache
      const cachedData = queryClient.getQueryData(queryKey);

      const shouldUseCache = cachedData && type === "url";

      if (shouldUseCache) {
        const data = cachedData as any;
        setSelectedContent(data.content);
        setSelectedContent(data.content);
      } else {
        const result = await axiosPost("/ai/fetch-trained-content", {
          sourceName: url,
          botCustomId: botData.botCustomId,
        });
        // Update the cache manually with the received data
        queryClient.setQueryData(queryKey, result.data.data);

        // Set the content state
        if (type === "url") {
          setSelectedContent(result.data.data.content);
        } else if (type === "file") {
          setSelectedUrl(result.data.data.title);
          setSelectedContent(result.data.data.content);
        }
      }
    } catch (error: any) {
      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "error",
          message: error.message || "Error fetching content",
        }),
      );
    } finally {
      setViewDetailsLoading(false);
    }
  };

  const handleMasterCheckboxChange = () => {
    if (isPostTrainingDelay) return;

    setIsAllChecked((prevState) => {
      // 1️⃣ Stop if ALL items are in progress or re-syncing
      // const allInProgress = combinedUrls.every(
      //   (item) => item.status === "In Progress" || item.status === "Re-syncing",
      // );

      // if (allInProgress) {
      //   return false;
      // }

      const newState = !prevState;

      if (newState) {
        // 2️⃣ Only select items NOT in progress & NOT re-syncing
        const selectedItems = combinedUrls.filter(
          (item) =>
            item.status !== "In Progress" &&
            // item.status !== "Re-syncing" &&
            !dataToBeSaved.some((saved) => saved.url === item.url),
        );

        setDataToBeSaved([...dataToBeSaved, ...selectedItems]);

        // 3️⃣ Same logic for resync items
        const selectedResyncItems = combinedUrls
          .filter((item) => {
            const compareUrl =
              item?.sourceType === "youtube" ? item.title : item.url;

            return (
              item.status !== "In Progress" &&
              // item.status !== "Re-syncing" &&
              !resyncData.some((saved) => saved.url === compareUrl)
            );
          })
          .map((item) => ({
            type: item?.sourceType ?? "urls",
            url: item?.sourceType === "youtube" ? item.title : item.url,
            status: item?.status,
          }));

        setResyncData((prev) => [...prev, ...selectedResyncItems]);
      } else {
        // 4️⃣ Unselect all
        setDataToBeSaved([]);
        setResyncData([]);
      }

      setCheckedState(
        combinedUrls.reduce((acc, data) => {
          if (data.status === "In Progress") return acc;
          return {
            ...acc,
            [data.url]: newState,
          };
        }, {}),
      );

      return newState;
    });
  };

  const sortByCharactersAscending = () => {
    setActiveSort("char_asc");
    dispatch(
      userSlice.actions.setToastPopUp({
        show: true,
        toastType: "success",
        message: "Links sorted in ascending order",
      }),
    );
  };

  const sortByCharactersDescending = () => {
    setActiveSort("char_desc");
    dispatch(
      userSlice.actions.setToastPopUp({
        show: true,
        toastType: "success",
        message: "Links sorted in descending order",
      }),
    );
  };
  const handleResync = async (data: any, type: string = "urls") => {
    try {
      const curDataset: any[] = [];

      for (const item of store.botData?.aiSource?.[type] || []) {
        const urlItem =
          type === "urls" ? item.url === data.url : item.title === data.title;

        if (urlItem) {
          curDataset.push({
            ...item,
            status: "Re-syncing",
          });
        } else {
          curDataset.push(item);
        }
      }

      storeDispatch({
        type: "set-aiSource",
        dataKey: type,
        dataSet: curDataset,
      });
      const sourcesToProcess = ["confluence", "notion", "googlepicker"];

      setDataToBeSaved((prevData) =>
        prevData.filter((item) => {
          return item.url !== data.url;
        }),
      );

      // setResyncData((prevData) => {
      //   console.log("prev data before filter:: ", prevData);
      //   (prevData.filter((item) => {
      //     if (type === "urls") {
      //       return item.url !== data.url;
      //     }
      //     return item.url !== data.title;
      //   }),
      //     console.log("prev data after filter:: ", prevData));
      // });
      setResyncData((prevData: any = []) => {
        const key = type === "urls" ? data.url : data.title;

        if (prevData.some((item) => item.url === key)) {
          return prevData;
        }

        return [...prevData, data];
      });

      // setCheckedState((prevState) => {
      //   const newState = {
      //     ...prevState,
      //     [data.url]: !prevState[data.url],
      //   };

      //   const allChecked = combinedUrls.every((item) => newState[item.url]);
      //   setIsAllChecked(allChecked);

      //   return newState;
      // });
      stopPolling();

      if (type === "urls") {
        await axiosPost("/train/url", {
          urls: [data.url],
          botCustomId: botData.botCustomId,
          botCreatedAt: botData.createdAt,
          resync: true,
          status: data.status,
        });
      } else {
        const payload = {
          link: data.title,
          botCustomId: botData.botCustomId,
          botCreatedAt: botData.createdAt,
          type,
          ...(sourcesToProcess?.includes(type) && {
            authId: data.authId || data.id,
          }),
        };

        await axiosPost("/ai/resync-content", payload);
      }
      // restartPolling();

      queryClient.removeQueries({
        queryKey: ["trainedContent", botData.botCustomId, data.url],
      });
    } catch (error: any) {
      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "error",
          message: error.message || "Error starting resyncing",
        }),
      );
    } finally {
      setIsRecyncing(false);
    }
  };

  const handleMultipleRecync = async () => {
    try {
      const groupedByType: Record<string, string[]> = {};
      const resyncAll = resyncData?.filter(
        (d) => d.status !== "Re-syncing" && d.status !== "In Progress",
      );
      setResyncData([]);
      setIsAllChecked(false);
      setDataToBeSaved([]);
      setCheckedState({});
      if (resyncAll?.length === 0) return;

      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "success",
          message: `${resyncAll.length} links added to resync.`,
        }),
      );
      resyncAll?.forEach((item) => {
        if (!groupedByType[item.type]) {
          groupedByType[item.type] = [];
        }
        groupedByType[item.type].push(item.url);
      });

      Object.entries(groupedByType).forEach(([type, urls]) => {
        const curDataset: any[] = [];
        for (const item of store.botData?.aiSource?.[type] || []) {
          const urlItem = urls?.filter((url) =>
            type === "youtube" ? url === item.title : url === item.url,
          );
          if (urlItem[0]) {
            curDataset.push({
              ...item,
              status: "Re-syncing",
            });
          } else {
            curDataset.push(item);
          }
        }
        storeDispatch({
          type: "set-aiSource",
          dataKey: type,
          dataSet: curDataset,
        });
      });
      stopPolling();
      if (groupedByType.urls?.length) {
        await axiosPost("/train/url", {
          urls: groupedByType.urls,
          botCustomId: botData.botCustomId,
          botCreatedAt: botData.createdAt,
          resync: true,
          status: groupedByType.status,
        });
      } else {
        delete groupedByType.urls;

        const payload = {
          links: groupedByType,
          botCustomId: botData.botCustomId,
          botCreatedAt: botData.createdAt,
        };

        axiosPost("/ai/resync-multiple", payload);
      }
      stopPolling();
    } catch (err) {
      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "error",
          message: "Error on resyncing",
        }),
      );
    }
  };

  const debouncedHandleMultipleRecync = debounce(handleMultipleRecync, 500);

  const sortByLastSyncedAscending = () => {
    setActiveSort("sync_asc");
    dispatch(
      userSlice.actions.setToastPopUp({
        show: true,
        toastType: "success",
        message: "Links sorted by last synced time in ascending order",
      }),
    );
  };

  const sortByLastSyncedDescending = () => {
    setActiveSort("sync_desc");
    dispatch(
      userSlice.actions.setToastPopUp({
        show: true,
        toastType: "success",
        message: "Links sorted by last synced time in descending order",
      }),
    );
  };

  const handleCheckboxChange = (data) => {
    if (data.status === "In Progress") return;
    setCheckedState((prevState) => {
      const newState = {
        ...prevState,
        [data.url]: !prevState[data.url],
      };

      setDataToBeSaved((prevData) => {
        const isAlreadyAdded = prevData.some((item) => item.url === data.url);

        if (newState[data.url] && !isAlreadyAdded) {
          return [...prevData, data];
        } else if (!newState[data.url] && isAlreadyAdded) {
          return prevData.filter((item) => item.url !== data.url);
        } else {
          return prevData;
        }
      });

      setResyncData((prevData) => {
        // normalize key: always match how we store `url`
        const normalizedUrl =
          data?.sourceType === "youtube" ? data.title : data.url;

        const isAlreadyAdded = prevData.some(
          (item) => item.url === normalizedUrl,
        );

        if (newState[data.url] && !isAlreadyAdded) {
          // Add new item
          return [
            ...prevData,
            {
              type: data?.sourceType || "urls",
              url: normalizedUrl,
              status: data?.status,
            },
          ];
        } else if (!newState[data.url] && isAlreadyAdded) {
          // Remove existing item
          return prevData.filter((item) => item.url !== normalizedUrl);
        } else {
          // Nothing changes
          return prevData;
        }
      });

      const allChecked = combinedUrls.every((item) => newState[item.url]);
      setIsAllChecked(allChecked);

      return newState;
    });
  };

  const handleDeleteUrl = async (data: any, index: number, type: any) => {
    setRemoveData({
      status: true,
      remove: async () => {
        try {
          setIsDeleting(true);
          setInProcess(true);

          const dataToProcess = Array.isArray(data) ? data : [data];

          // Get document IDs that will be deleted
          const deletedDocumentIds = dataToProcess
            .map((item) => item.id)
            .filter(Boolean);

          // IMMEDIATELY mark as deleting to stop polling
          if (deletedDocumentIds.length > 0 && markDocumentsAsDeleting) {
            markDocumentsAsDeleting(deletedDocumentIds);
          }

          const regularUrls: any = [];
          const youtubeUrls: any = [];

          dataToProcess.forEach((item) => {
            if (
              item.sourceType === "youtube" ||
              type === "youtube" ||
              item.type === "youtube"
            ) {
              youtubeUrls.push(item ?? data);
            } else regularUrls.push(item ?? data);
          });

          // Prepare requests for each type that has items
          const requests: any = [];

          if (regularUrls.length > 0) {
            // Prepare sources with character count and status
            const sourcesWithData = regularUrls.map((item) => ({
              url: item.url || item.link,
              characterCount: item.characterCount || 0,
              status: item.status || "",
            }));

            requests.push(
              axiosPost("/ai/delete-content", {
                sources: sourcesWithData,
                botCustomId,
                botCreatedAt,
                sourceType: "urls",
              }),
            );
          }

          if (youtubeUrls.length > 0) {
            // Prepare sources with character count and status
            const sourcesWithData = youtubeUrls.map((item) => ({
              url: item.url,
              characterCount:
                item.characterCount || item.transcript?.length || 0,
              status: item.status || "",
            }));

            requests.push(
              axiosPost("/ai/delete-content", {
                sources: sourcesWithData,
                botCustomId,
                botCreatedAt,
                sourceType: "youtube",
              }),
            );
          }

          // Execute all requests in parallel
          const responses = await Promise.all(requests);

          // Check if all requests were successful
          const allSuccessful = responses.every(
            (response) => response.data.status === "success",
          );

          if (allSuccessful) {
            // Mark as successfully deleted
            if (deletedDocumentIds.length > 0 && markDocumentsAsDeleted) {
              markDocumentsAsDeleted(deletedDocumentIds);
            }

            const totalUsed = Math.min(
              ...responses.map((res) => res.data.characterUsed),
            );

            storeDispatch({
              type: "set-botData",
              botData: {
                ...store.botData,
                aiBotConfig: {
                  ...store.botData.aiBotConfig,
                  characterUsed: totalUsed,
                },
              },
            });

            setDataToBeSaved([]);
            setResyncData([]);

            const updatedUrls = combinedUrls.filter((_, i) => i !== index);
            queryClient.invalidateQueries({ queryKey: ["bot", "completeBot"] });

            storeDispatch({
              type: "set-aiSource",
              dataKey: type === "youtube" ? "youtube" : "urls",
              dataSet: updatedUrls,
            });

            setSearchedLinks(updatedUrls);
            setPaginatedLinks(updatedUrls.slice(0, itemsPerPage));

            // Refetch company data to get updated character limits
            if (refetchCompany) {
              refetchCompany();
            }

            dispatch(
              userSlice.actions.setToastPopUp({
                show: true,
                toastType: "success",
                message: "Training Data Removed Successfully",
              }),
            );
          } else {
            // If deletion failed, clear the deleting status
            if (deletedDocumentIds.length > 0 && clearDeletionTracking) {
              clearDeletionTracking(deletedDocumentIds);
            }

            dispatch(
              userSlice.actions.setToastPopUp({
                show: true,
                toastType: "error",
                message: "Failed to delete some content",
              }),
            );
          }
        } catch (error: any) {
          // If error occurs, clear the deleting status
          const dataToProcess = Array.isArray(data) ? data : [data];
          const deletedDocumentIds = dataToProcess
            .map((item) => item.id)
            .filter(Boolean);

          if (deletedDocumentIds.length > 0 && clearDeletionTracking) {
            clearDeletionTracking(deletedDocumentIds);
          }

          dispatch(
            userSlice.actions.setToastPopUp({
              show: true,
              toastType: "error",
              message: error.message || "Error deleting content",
            }),
          );
        } finally {
          setIsDeleting(false);
          setCheckedState({});
          setInProcess(false);
          setIsAllChecked(false);
          setRemoveData((prevState) => ({
            ...prevState,
            status: false,
          }));
        }
      },
    });
  };

  const debouncedHandleDeleteUrl = useDebounce(handleDeleteUrl, 100);

  const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
  const botCustomId = store.botData.botCustomId;
  const botCreatedAt = store.botData.createdAt;
  const [deletePopup, setDeletePopup] = useState<boolean>(false);

  useEffect(() => {
    if (combinedUrls) {
      let links = combinedUrls;

      const statusFilteredLinks =
        selectedStatus.text === "All Statuses" || selectedStatus.text === ""
          ? links
          : links.filter((link) => link.status === selectedStatus.text);

      const searchFilteredLinks = !searchTerm
        ? statusFilteredLinks
        : statusFilteredLinks.filter((link) =>
            link?.url?.toLowerCase().includes(searchTerm.toLowerCase()),
          );

      const sortedLinks = applySort(searchFilteredLinks, activeSort);

      if (
        JSON.stringify(sortedLinks) !== JSON.stringify(searchedLinks) ||
        sortedLinks.length !== searchedLinks.length
      ) {
        setSearchedLinks(sortedLinks);
      }
    }
  }, [
    combinedUrls,
    activeSort,
    searchTerm,
    selectedStatus.text,
    applySort,
    searchedLinks,
  ]);

  useEffect(() => {
    if (trainedFiles) {
      setSearchedFiles(trainedFiles);
    }
  }, [botData]);

  useEffect(() => {
    paginateLinks();
  }, [searchedLinks, currentPage]);
  useEffect(() => {
    paginateFiles();
  }, [searchedFiles, fileCurrentPage]);
  useEffect(() => {
    // When trainedFiles changes and contains items, start the delay
    if (trainedFiles?.length > 0) {
      setIsPostTrainingDelay(true);
      const timer = setTimeout(() => {
        setIsPostTrainingDelay(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [trainedFiles]);

  function deleteItemFromDataSource(source: string, itemIndex: number) {
    const updatedItems = dataSources[source].filter(
      (_, index) => index !== itemIndex,
    );
    storeDispatch({
      type: "data-sources-update",
      dataSources: {
        ...dataSources,
        [source]: updatedItems,
      },
    });
  }
  const handleTrain = (event) => {
    if (event.keyCode === 13 || event.which === 13) {
      // fetchExtraUrl(0, true);
      fetchExtraUrl(extraUrl, "extra", [], false, true);
    }
  };

  const handleDropdowns = (rowId, type, value) => {
    const triggerKey = `${type}-${rowId}`;
    const triggerElement = dropdownRef.current[triggerKey];

    if (triggerElement && value) {
      const rect = triggerElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      requestAnimationFrame(() => {
        const dropdownId = `#dropdown-${type}-${rowId}`;
        const observer = new MutationObserver(() => {
          const dropdownElement = document.querySelector(dropdownId);
          if (!dropdownElement) return;

          const dropdownRect = dropdownElement.getBoundingClientRect();
          const spaceBelow = viewportHeight - rect.bottom;
          const spaceAbove = rect.top;

          const shouldOpenUpwards =
            dropdownRect.height > spaceBelow && spaceAbove > spaceBelow;

          setDropdownPosition({
            top: shouldOpenUpwards
              ? rect.top + window.scrollY - dropdownRect.height
              : rect.bottom + window.scrollY,
            left: rect.right + window.scrollX - 150,
            width: rect.width,
            maxHeight: shouldOpenUpwards
              ? rect.top + window.scrollY
              : rect.bottom + window.scrollY,
          });

          observer.disconnect();
        });

        observer.observe(document.body, { childList: true, subtree: true });

        setDropdowns((prevState) => ({
          ...prevState,
          [rowId]: {
            ...(prevState[rowId] || {}),
            [type]: value,
          },
        }));
      });
    } else {
      setDropdowns((prevState) => ({
        ...prevState,
        [rowId]: {
          ...(prevState[rowId] || {}),
          [type]: value,
        },
      }));
    }
  };

  function toggleDropdowns(type: string, show: boolean = false) {
    if (show) {
      setDrpToggle({ ...dropdownState, [type]: show });
    } else {
      setDrpToggle(dropdownState);
    }
  }

  const handleStatusChange = (status) => {
    setSelectedStatus({
      text: status.text,
      icon: status.iconComponent,
    });

    const statusFiltered =
      status.text === "All Statuses"
        ? combinedUrls
        : combinedUrls.filter((data) => data.status === status.text);

    const searchFiltered = !searchTerm
      ? statusFiltered
      : statusFiltered.filter((link) =>
          link?.url?.toLowerCase().includes(searchTerm.toLowerCase()),
        );

    setSearchedLinks(searchFiltered);
    setCurrentPage(1);
    setPaginatedLinks(searchFiltered.slice(0, itemsPerPage));
  };

  const handleFileStatusChange = (status) => {
    setSelectedFileStatus({
      text: status.text,
      icon: status.iconComponent,
    });
    const statusFiltered =
      status.text === "All Statuses"
        ? trainedFiles
        : trainedFiles.filter((file) => file.status === status.text);
    const searchFiltered = !fileSearchQuery
      ? statusFiltered
      : statusFiltered?.filter((file) => {
          const titleOrName = file.title || file.name || "";
          return titleOrName
            .toLowerCase()
            .includes(fileSearchQuery.toLowerCase());
        });

    setSearchedFiles(searchFiltered);
    setFileCurrentPage(1);
    setPaginatedFiles(searchFiltered.slice(0, itemsPerPage));
  };

  const handleFileRemove = (removeFn, data) => {
    if (Array.isArray(data) && !selectedIds.length) return;

    setRemoveData({
      status: true,
      remove: async () => {
        setIsDeleting(true);
        try {
          await removeFn(data);
          if (data && data.sourceType) {
            const sourceItems = trainedSource[data.sourceType] || [];
            const itemIndex = sourceItems.findIndex(
              (item) =>
                (item.id || item.title) === (data.fileId || data.source),
            );

            if (itemIndex !== -1) {
              deleteItemFromDataSource(data.sourceType, itemIndex);
            }
          }
        } finally {
          setIsDeleting(false);
          setRemoveData((prevState) => ({
            ...prevState,
            status: false,
          }));
        }
      },
    });
  };

  async function deleteMultipleTrainDocument() {
    try {
      if (!paginatedFiles) throw new Error("No source found to delete");
      const source: string[] = selectedIds;
      let size = 0;
      // for (const data of paginatedFiles) {
      //   if (selectedIds.includes(data.title)) {
      //     size += data.size;
      //   }
      // }

      setInProcess(true);
      const res = await axiosPost("/ai/delete-content", {
        sources: source,
        size: size ?? 0,
        botCustomId: botData.botCustomId,
        botCreatedAt: botData.createdAt,
        sourceType: "documents",
      });

      // storeDispatch({
      //   type: "set-characterCount",
      //   characterCount: res.data.characterUsed,
      // });
      storeDispatch({
        type: "set-botData",
        botData: {
          ...store.botData,
          aiBotConfig: {
            ...store.botData.aiBotConfig,
            characterUsed: res.data.characterUsed,
          },
        },
      });
      parentForceReload(true);

      // Refetch company data to get updated character limits
      if (refetchCompany) {
        refetchCompany();
      }

      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "success",
          message:
            "Selected data has been successfully removed from the training data.",
        }),
      );

      setSelectedIds((selectedIds) =>
        selectedIds.filter((id) => !source?.includes(id)),
      );
      setSelectedAll(false);
    } catch (err: any) {
      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "error",
          message: err.message,
        }),
      );
    } finally {
      setInProcess(false);
    }
  }

  // async function deleteTrainDocument({
  //   source,
  //   sourceType,
  // }: {
  //   source: string[];
  //   sourceType: string;
  // }) {
  //   try {
  //     if (!source) throw new Error("No source found to delete");

  //     setInProcess(true);
  //     const res = await axiosPost("/ai/delete-content", {
  //       sources: [source],
  //       size: size ?? 0,
  //       botCustomId: botData.botCustomId,
  //       botCreatedAt: botData.createdAt,
  //       sourceType: sourceType,
  //     });

  //     parentForceReload(true);
  //     setRemoveData({ ...removeData, status: false });
  //     dispatch(
  //       userSlice.actions.setToastPopUp({
  //         show: true,
  //         toastType: "success",
  //         message:
  //           "Selected data has been successfully removed from the training data.",
  //       }),
  //     );
  //   } catch (err: any) {
  //     dispatch(
  //       userSlice.actions.setToastPopUp({
  //         show: true,
  //         toastType: "error",
  //         message: err.message,
  //       }),
  //     );
  //   } finally {
  //     setInProcess(false);
  //   }
  // }

  const deleteTrainDocument = async ({ source, sourceType }) => {
    try {
      if (!source || source.length === 0)
        throw new Error("No source found to delete");

      const convertedArray = Array.isArray(source) ? source : [source];
      const documentIds = convertedArray.map((item) => item.id).filter(Boolean);

      // Mark as deleting to stop polling
      if (documentIds.length > 0 && markDocumentsAsDeleting) {
        markDocumentsAsDeleting(documentIds);
      }

      const updatedArray = convertedArray.map((item) => ({
        ...item,
        ...(item.characterCount === undefined && {
          characterCount: item.text.length,
        }),
      }));

      setInProcess(true);

      const res = await axiosPost("/ai/delete-content", {
        sources: Array.isArray(updatedArray) ? updatedArray : [updatedArray],
        size: size ?? 0,
        botCustomId: botData.botCustomId,
        botCreatedAt: botData.createdAt,
        sourceType,
      });

      // Mark as successfully deleted
      if (documentIds.length > 0 && markDocumentsAsDeleted) {
        markDocumentsAsDeleted(documentIds);
      }

      storeDispatch({
        type: "set-botData",
        botData: {
          ...store.botData,
          aiBotConfig: {
            ...store.botData.aiBotConfig,
            characterUsed: res.data.characterUsed,
          },
        },
      });

      queryClient.invalidateQueries({ queryKey: ["bot", "completeBot"] });
      parentForceReload(true);
      setRemoveData({ ...removeData, status: false });

      // Refetch company data to get updated character limits
      if (refetchCompany) {
        refetchCompany();
      }

      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "success",
          message:
            "Selected data has been successfully removed from the training data.",
        }),
      );
    } catch (err: any) {
      // If error occurs, clear the deleting status
      const convertedArray = Array.isArray(source) ? source : [source];
      const documentIds = convertedArray.map((item) => item.id).filter(Boolean);

      if (documentIds.length > 0 && clearDeletionTracking) {
        clearDeletionTracking(documentIds);
      }

      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "error",
          message: err.message,
        }),
      );
    } finally {
      setInProcess(false);
    }
  };

  const formatTime = (time: number): string => {
    if (isNaN(time) || time < 0) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setCurrentPage(1);
    filterLinks(value, setSearchedLinks, setPaginatedLinks, selectedStatus);
  };

  const handleSearchFiles = (event) => {
    const value = event.target.value;
    setFileSearchQuery(value);
    setFileCurrentPage(1);
    filterFiles(value, setSearchedFiles, setPaginatedFiles, selectedFileStatus);
  };

  const renderFileType = useCallback((type) => {
    return type.split(".").at(-1);
  }, []);

  const filterLinks = (
    searchQuery,
    setSearchedLinks,
    setPaginatedLinks,
    selectedStatus,
  ) => {
    const statusFilteredLinks =
      selectedStatus.text === "All Statuses" || selectedStatus.text === ""
        ? combinedUrls
        : combinedUrls.filter((link) => link.status === selectedStatus.text);

    if (!searchQuery) {
      setSearchedLinks(statusFilteredLinks);
      setPaginatedLinks(statusFilteredLinks.slice(0, itemsPerPage));
      return;
    }

    const filtered = statusFilteredLinks.filter((link) =>
      link?.url?.toLowerCase().includes(searchQuery.toLowerCase()),
    );

    setSearchedLinks(filtered);
    setPaginatedLinks(filtered.slice(0, itemsPerPage));
  };

  const filterFiles = (
    searchQuery,
    setSearchedFiles,
    setPaginatedFiles,
    selectedFileStatus,
  ) => {
    const statusFilteredFiles =
      selectedFileStatus.text === "All Statuses" ||
      selectedFileStatus.text === ""
        ? trainedFiles
        : trainedFiles.filter(
            (file) => file.status === selectedFileStatus.text,
          );
    if (!searchQuery) {
      setSearchedFiles(statusFilteredFiles);
      setPaginatedFiles(statusFilteredFiles.slice(0, itemsPerPage));
      return;
    }
    const filtered = statusFilteredFiles.filter((file) => {
      const titleOrName = file.title || file.name || "";
      return titleOrName
        .toLowerCase()
        .includes(searchQuery?.toLowerCase() ?? "");
    });

    setSearchedFiles(filtered);
    setPaginatedFiles(filtered.slice(0, itemsPerPage));
  };

  const paginateLinks = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedLinks(searchedLinks.slice(startIndex, endIndex));
  };

  const paginateFiles = () => {
    const startIndex = (fileCurrentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedFiles(searchedFiles.slice(startIndex, endIndex));
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const handleFilePageChange = (newPage) => {
    setFileCurrentPage(newPage);
  };

  const updateSyncTimeInDB = async (url, syncIntervalDays) => {
    try {
      const response = await axiosPost("/ai/update-content", {
        url,
        syncIntervalDays,
        botCustomId: botData.botCustomId,
      });

      queryClient.invalidateQueries({ queryKey: ["bot", "completeBot"] });
    } catch (error) {
      console.error("Error updating sync time:", error);
    }
  };

  const debouncedUpdateSyncTime = useDebounce(updateSyncTimeInDB, 600);

  const handleSyncTimeChange = (index, item, data) => {
    const TimeMapping = {
      Off: 0,
      "Every week": 7,
      "Every 2 weeks": 14,
      "Every 4 weeks": 28,
    };
    const newSyncInterval = TimeMapping[item] ?? 0;

    setSyncTimes((prev) => ({
      ...prev,
      [data.url]: item,
    }));
    handleDropdowns(index, "syncTime", false);
    if (item == syncTimeMapping[data.syncIntervalDays]) return;
    debouncedUpdateSyncTime(data.url, newSyncInterval);
  };

  // async function deleteUrls(sources: string[], sourceType: string) {
  //   try {
  //     if (deleteLoader) return;

  //     setDeleteLoader(true);
  //     const res = await axiosPost("/ai/delete-content", {
  //       sources,
  //       botCustomId,
  //       botCreatedAt,
  //       sourceType,
  //     });
  //     const message = {
  //       youtube:
  //         "Selected yotube link has been successfully removed from the training data.",
  //       urls: "Link has been deleted successfully.",
  //     };
  //     dispatch(
  //       userSlice.actions.setToastPopUp({
  //         show: true,
  //         toastType: "success",
  //         message:
  //           window.screen.width >= 1279
  //             ? res.data.message
  //             : message[sourceType],
  //       }),
  //     );
  //     onReload(false);
  //     setDeleteLoader(false);
  //     setDeletePopup(false);

  //     const updatedUrls = combinedUrls.filter((item) => {
  //       if (item.sourceType === "youtube") {
  //         return !sources.includes(item.title);
  //       }
  //       return !sources.includes(item.url);
  //     });
  //     // setCombinedUrls(updatedUrls);
  //   } catch (err: any) {
  //     dispatch(
  //       userSlice.actions.setToastPopUp({
  //         show: true,
  //         toastType: "error",
  //         message: err.message,
  //       }),
  //     );
  //     setDeleteLoader(false);
  //     setDeletePopup(false);
  //   }
  // }

  function selectAll() {
    if (isPostTrainingDelay) return;
    if (selectedAll) {
      setSelectedIds([]);
      setSelectedAll(false);
    } else {
      const filteredFiles = paginatedFiles.filter(
        (file) => file.status !== "In Progress",
      );

      setSelectedIds(filteredFiles);
      setSelectedAll(filteredFiles.length > 0);
    }
  }

  function toggleSelection(item: any) {
    if (isPostTrainingDelay) return;
    // if (item?.status === "In Progress") return;
    // console.log(selectedIds);
    setSelectedIds((prevSelected: any) => {
      const exists = prevSelected.some((i) => i.id === item.id);
      return exists
        ? prevSelected.filter((i) => i.id !== item.id)
        : [...prevSelected, item];
    });
  }

  const addLinkBtnRef = useRef<HTMLButtonElement>(null);
  const addLinkInputRef = useRef<HTMLTableRowElement>(null);

  const checkboxRef = useRef<HTMLDivElement>(null);

  const defaultOptions = {
    loop: false,
    autoplay: false,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const refreshFilters = () => {
    filterFiles(
      fileSearchQuery,
      setSearchedFiles,
      setPaginatedFiles,
      selectedFileStatus,
    );
  };

  async function cancelTraining() {
    try {
      if (trainingCancelLoader) return;
      setTrainingCancelLoader(true);
      await axiosPost("/train/cancel", {
        botCustomId: botCustomId,
      });

      setTrainingCancelLoader(false);
      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "success",
          message: "Training cancelled successfully",
        }),
      );
      // const hasSelectedItems = dataToBeSaved.length > 0;

      // if (hasSelectedItems) {
      //   const inProgressLinks = dataToBeSaved.filter(
      //     (item) => item.status === "In Progress",
      //   );

      //   if (inProgressLinks.length === 0) {
      //     setTrainingCancelLoader(false);
      //     return;
      //   }

      //   const urlsToCancel = inProgressLinks.map((item) =>
      //     item.sourceType === "youtube" ? item.title : item.url,
      //   );

      //   await axiosPost("/train/cancel", {
      //     botCustomId: botCustomId,
      //     urls: urlsToCancel,
      //   });

      //   setDataToBeSaved([]);
      //   setResyncData([]);
      //   setCheckedState({});
      //   setIsAllChecked(false);

      //   setTrainingCancelLoader(false);
      //   dispatch(
      //     userSlice.actions.setToastPopUp({
      //       show: true,
      //       toastType: "success",
      //       message: `Training cancelled for ${inProgressLinks.length} selected link${inProgressLinks.length > 1 ? "s" : ""}`,
      //     }),
      //   );
      // } else {
      //   await axiosPost("/train/cancel", {
      //     botCustomId: botCustomId,
      //   });

      //   setTrainingCancelLoader(false);
      //   dispatch(
      //     userSlice.actions.setToastPopUp({
      //       show: true,
      //       toastType: "success",
      //       message: "Training cancelled successfully",
      //     }),
      //   );
      // }
      queryClient.invalidateQueries({ queryKey: ["bot", "completeBot"] });
    } catch (err: any) {
      console.log(err);

      setTrainingCancelLoader(false);
      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "error",
          message:
            err.response?.data?.message ??
            err.message ??
            "Something went wrong, please try again.",
        }),
      );
    }
  }

  return (
    <>
      {!(selectedSourceTab == "updated_bot_qa") && (
        <div
          className={`choose-source-container sources-tab-wrapper pd-20 ai-intro-first mb-0 !pb-[0px] ${(selectedSourceTab == "upload_source" && files.length) || selectedSourceTab == "text" ? "!rounded-b-none" : ""} ${showPreview ? "chat_is_open" : ""}`}
        >
          {/* <VoiceCoachBanner setSelectedSetupTab={setSelectedSetupTab}/> */}
          {selectedSourceTab == "source_link" && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
              className="fx-d-col h-100 source-link-wrapper flex pb-[20px]"
            >
              <h3 className="!mb-[10px] flex items-center gap-[15px] text-[14px] font-medium text-text-clr">
                Source Link
                {isOld && (
                  <div className="character-count-wrapper flex items-center gap-[10px]">
                    <span className="!ms-[0px] h-[24px] w-[1px] bg-[#666] opacity-[0.3]"></span>
                    <p
                      className={`character-count pointer relative z-[5] flex items-center gap-[4px] rounded-[5px] px-[8px] py-[6px] text-[13px] font-medium capitalize leading-normal ${useFormatNumber(characterUsed) === useFormatNumber(characterLimit) ? "bg-[#FFE8E9] text-[#fb5f66]" : "bg-[#FEF2CC] text-[#9A6815]"} `}
                    >
                      <CharacterLimitIcon
                        color={
                          useFormatNumber(characterUsed) ===
                          useFormatNumber(characterLimit)
                            ? "#fb5f66"
                            : "#9A6815"
                        }
                      />
                      {!characterLimit || characterLimit === 0 ? (
                        <div className="rotating-svg">
                          <TrainingProgressIcon />
                        </div>
                      ) : (
                        `${useFormatNumber(characterUsed)} / ${useFormatNumber(characterLimit)}`
                      )}
                      <div className="none absolute left-[0] top-[35px] z-[1] w-[280px] cursor-default flex-col items-center gap-[10px] rounded-[8px] bg-[#222] p-[10px]">
                        {useFormatNumber(characterUsed) ===
                        useFormatNumber(characterLimit) ? (
                          <p className="text-center text-[12px] font-normal normal-case not-italic leading-[17px] text-[#fb5f66]">
                            Your current plan doesn't support more than
                            <b className="font-medium">
                              {" "}
                              {useFormatNumber(characterLimit)} Characters.{" "}
                            </b>
                            {plan.name !== "Professional"
                              ? "Upgrade to the Professional plan to unlock this feature."
                              : "If you want more, you have to buy the add-on."}
                          </p>
                        ) : (
                          <p className="text-center text-[12px] font-normal normal-case not-italic leading-[17px] text-white/80">
                            Agents can use a maximum of <br />
                            <b className="font-medium">
                              {useFormatNumber(characterLimit)} Characters
                            </b>
                            , including link content. Anything over that limit
                            won't be used.
                          </p>
                        )}
                        {plan.name !== "Professional" ? (
                          <button
                            className="pointer h-[30px] w-full rounded-[8px] bg-[#fb5f66] text-[12px] font-normal leading-normal text-white"
                            onClick={() => {
                              setBuyAddOn(false);
                              setLeaveModal(true);
                            }}
                          >
                            Upgrade Plan
                          </button>
                        ) : (
                          <button
                            className="pointer h-[30px] w-full rounded-[8px] bg-[#fb5f66] text-[12px] font-normal leading-normal text-white"
                            onClick={() => {
                              setBuyAddOn(true);
                              setLeaveModal(true);
                            }}
                          >
                            Buy add-on
                          </button>
                        )}
                      </div>
                    </p>
                  </div>
                )}
              </h3>
              <div className="flex h-full w-full flex-col overflow-auto">
                <div className="fx website__link gap-10">
                  <InputField
                    websiteUrl={websiteUrl}
                    setWebsiteUrl={setWebsiteUrl}
                    fetchUrl={fetchUrl}
                    onDataChange={onDataChange}
                    searchData={searchData}
                  />
                  <button
                    className={
                      !websiteUrl?.length || fileLoader
                        ? "fetch-btn fetch-disable flex items-center justify-center"
                        : "fetch-btn flex items-center justify-center"
                    }
                    onClick={
                      !websiteUrl?.length || fileLoader ? undefined : fetchUrl
                    }
                  >
                    {fetchLoader ? (
                      <div className="fx al-fx-end jstfy-cnt fetching-link gap-6">
                        Fetching <ThreeDot />
                      </div>
                    ) : (
                      "Fetch Links"
                    )}
                  </button>
                </div>
                <div className="border-[rgba(102, 102, 102, 0.20)] mt-20 flex h-max flex-col border-t pt-20">
                  <h2 className="text-[16px] font-medium text-text-clr">
                    Trained Links
                  </h2>
                  <div className="trained_links_wrapper p-relative new-scrollbar mt-10">
                    {combinedUrls?.length ? (
                      <>
                        <div className="table_actions sticky left-0 top-0 z-[2] flex items-center justify-between gap-10 bg-[#f9f9f9] px-[20px] py-3">
                          <div className="flex items-center gap-10">
                            <div className="search_div border-[rgba(0, 0, 0, 0.10)] flex h-[44px] w-[300px] items-center gap-10 rounded-[10px] border border-solid bg-white px-[16px] py-[13px]">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={15}
                                height={14}
                                viewBox="0 0 15 14"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_190_16528)">
                                  <path
                                    d="M5.60625 0C6.98538 0 8.30802 0.547855 9.28321 1.52304C10.2584 2.49823 10.8063 3.82087 10.8063 5.2C10.8063 6.488 10.3342 7.672 9.55825 8.584L9.77425 8.8H10.4062L14.4062 12.8L13.2063 14L9.20625 10V9.368L8.99025 9.152C8.04669 9.95742 6.84682 10.3999 5.60625 10.4C4.22712 10.4 2.90448 9.85215 1.92929 8.87696C0.954105 7.90177 0.40625 6.57913 0.40625 5.2C0.40625 3.82087 0.954105 2.49823 1.92929 1.52304C2.90448 0.547855 4.22712 0 5.60625 0ZM5.60625 1.6C3.60625 1.6 2.00625 3.2 2.00625 5.2C2.00625 7.2 3.60625 8.8 5.60625 8.8C7.60625 8.8 9.20625 7.2 9.20625 5.2C9.20625 3.2 7.60625 1.6 5.60625 1.6Z"
                                    fill="#444444"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_190_16528">
                                    <rect
                                      width={14}
                                      height={14}
                                      fill="white"
                                      transform="translate(0.40625)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <input
                                type="text"
                                placeholder="Search link"
                                className="h-[unset] border-none bg-transparent p-0 outline-none"
                                value={searchTerm}
                                onChange={handleSearch}
                              />
                            </div>

                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                const rect =
                                  e.currentTarget.getBoundingClientRect();
                                const viewportHeight = window.innerHeight;
                                const spaceBelow = viewportHeight - rect.bottom;
                                const maxHeight = Math.min(
                                  spaceBelow - 20,
                                  300,
                                ); // 20px padding from viewport edge
                                setDropdownPosition({
                                  top: rect.bottom + window.scrollY,
                                  left: rect.left + window.scrollX,
                                  width: rect.width,
                                  maxHeight: maxHeight > 50 ? maxHeight : 150,
                                });
                                toggleDropdowns(
                                  "linkStatus",
                                  !drpToggle.linkStatus,
                                );
                              }}
                              onMouseLeave={() =>
                                toggleDropdowns("linkStatus", false)
                              }
                              className="status_dropdown statuses_drp cp border-[rgba(0, 0, 0, 0.10)] relative flex !h-[44px] w-max items-center justify-between gap-[10px] rounded-[10px] border border-solid bg-white px-[16px] py-[12px] text-[14px]"
                            >
                              {selectedStatus.text ? (
                                <span className="flex items-center gap-[6px] text-[14px]">
                                  {selectedStatus.icon} {selectedStatus.text}
                                </span>
                              ) : (
                                "All Statuses"
                              )}
                              <span
                                className={`transition-transform duration-300 ${drpToggle.linkStatus ? "rotate-180" : "rotate-0"}`}
                              >
                                <DownArrIconSvg />
                              </span>

                              {drpToggle.linkStatus &&
                                createPortal(
                                  <ul
                                    className={`status_dropdown_list trained_data-statuses grey-scrollbar absolute z-[999] overflow-auto rounded-[8px] ${fromOutgrow ? "outgrow" : ""}`}
                                    ref={dropdownRef}
                                    style={{
                                      top: `${dropdownPosition.top}px`,
                                      left: `${dropdownPosition.left}px`,
                                      maxHeight: `${dropdownPosition.maxHeight}px`,
                                    }}
                                    onMouseLeave={() =>
                                      toggleDropdowns("linkStatus", false)
                                    }
                                  >
                                    {statuses.map((item, index) => {
                                      return (
                                        <li
                                          key={index}
                                          className="flex cursor-pointer items-center gap-[6px] text-[14px]"
                                          onClick={() => {
                                            handleStatusChange(item);
                                            toggleDropdowns(
                                              "linkStatus",
                                              false,
                                            );
                                          }}
                                        >
                                          {item.iconComponent}
                                          {item.text}
                                        </li>
                                      );
                                    })}
                                  </ul>,
                                  document.getElementById(
                                    "dropdown-portal",
                                  ) as HTMLElement,
                                )}
                            </div>
                          </div>
                          <div className="flex items-center gap-10">
                            {/* <div
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleDropdowns(
                            "linkAutoSync",
                            !drpToggle.linkAutoSync,
                          );
                        }}
                        onMouseLeave={() =>
                          toggleDropdowns("linkStatus", false)
                        }
                        className="status_dropdown statuses_drp cp border-[rgba(0, 0, 0, 0.10)] relative flex w-max items-center justify-between gap-[10px] rounded-[10px] border border-solid bg-white px-[16px] py-[12px]"
                      >
                        {selectedSync ? (
                          <span className="flex items-center gap-[6px]">
                            {selectedSync}
                          </span>
                        ) : (
                          "Auto-sync"
                        )}
                        <span
                          className={`transition-transform duration-300 ${drpToggle.linkAutoSync ? "rotate-180" : "rotate-0"}`}
                        >
                          <DownArrIconSvg />
                        </span>

                        {drpToggle.linkAutoSync && (
                          <ul
                            className="status_dropdown_list absolute !left-[-50px] top-[50px] z-[1] !w-[208px] overflow-hidden rounded-[8px]"
                            ref={dropdownRef}
                          >
                            <h4 className="border-b border-[rgba(0,0,0,0.10)] text-[14px] font-medium !text-[#444]">
                              Auto-sync
                            </h4>
                            {Object.values(syncTimeMapping).map((item, idx) => (
                              <li
                                key={idx}
                                className="flex items-center gap-[6px]"
                                onClick={() => {
                                  toggleDropdowns("linkStatus", false);
                                  setSelectedSync(item);
                                }}
                              >
                                {item}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div> */}
                            <div className="flex gap-[8px]">
                              {showTrainCancelBtnUrl && (
                                <button
                                  className={`cancel-training-btn flex items-center gap-[5px] !rounded-[8px] !border !border-black/10 !bg-white !p-[9px] text-[13px] !text-[#666] ${inProcess ? "pointer-events-none opacity-50" : ""}`}
                                  onClick={cancelTraining}
                                >
                                  <svg
                                    width={18}
                                    height={18}
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M11.2496 11.25L6.75 6.75M6.75048 11.25L11.25 6.75"
                                      stroke="#666666"
                                      strokeWidth={1.125}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9Z"
                                      stroke="#666666"
                                      strokeWidth={1.125}
                                    />
                                  </svg>
                                  {trainingCancelLoader
                                    ? "Cancelling..."
                                    : "Cancel Training"}
                                  <span className="text-[13px] font-medium text-[#fb5f66]">
                                    (
                                    {
                                      combinedUrls.filter(
                                        (link) => link.status === "In Progress",
                                      ).length
                                    }
                                    )
                                  </span>
                                  <span className="cancel-training-tooltip">
                                    Cancels training for{" "}
                                    <span>
                                      {
                                        combinedUrls.filter(
                                          (link) =>
                                            link.status === "In Progress",
                                        ).length
                                      }{" "}
                                      in-progress
                                    </span>{" "}
                                    links. Completed links won’t be affected.
                                  </span>
                                </button>
                              )}
                              <button
                                className={`!border-[rgba(251, 95, 102, 0.70)] flex items-center gap-[5px] !p-[9px] !text-[13px] ${inProcess ? "pointer-events-none opacity-50" : ""}`}
                                onClick={() => {
                                  if (focusRef.current) {
                                    focusRef.current.focus();
                                  }
                                  if (!dataToBeSaved.length) {
                                    setShowAddLink(!showAddLink);

                                    // Clear the input field and search term when opening the Add Link panel
                                    if (!showAddLink) {
                                      setExtraUrl("");
                                      setSearchTerm(""); // Clear the search text
                                      // Re-filter links with empty search term
                                      filterLinks(
                                        "",
                                        setSearchedLinks,
                                        setPaginatedLinks,
                                        selectedStatus,
                                      );
                                    }
                                  } else {
                                    debouncedHandleDeleteUrl(dataToBeSaved, 0);
                                  }
                                }}
                                ref={addLinkBtnRef}
                              >
                                {dataToBeSaved.length ? (
                                  <>
                                    <svg
                                      width={18}
                                      height={18}
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.50098 3.75H10.501C10.501 2.92157 9.82943 2.25 9.00098 2.25C8.17253 2.25 7.50098 2.92157 7.50098 3.75ZM6.37598 3.75C6.37598 2.30025 7.55123 1.125 9.00098 1.125C10.4507 1.125 11.626 2.30025 11.626 3.75H15.9385C16.2491 3.75 16.501 4.00184 16.501 4.3125C16.501 4.62316 16.2491 4.875 15.9385 4.875H14.9492L14.0702 13.9584C13.9307 15.4001 12.7191 16.5 11.2707 16.5H6.73124C5.28288 16.5 4.07134 15.4001 3.93182 13.9584L3.05279 4.875H2.06348C1.75282 4.875 1.50098 4.62316 1.50098 4.3125C1.50098 4.00184 1.75282 3.75 2.06348 3.75H6.37598ZM7.87598 7.3125C7.87598 7.00184 7.62413 6.75 7.31348 6.75C7.00282 6.75 6.75098 7.00184 6.75098 7.3125V12.9375C6.75098 13.2482 7.00282 13.5 7.31348 13.5C7.62413 13.5 7.87598 13.2482 7.87598 12.9375V7.3125ZM10.6885 6.75C10.9991 6.75 11.251 7.00184 11.251 7.3125V12.9375C11.251 13.2482 10.9991 13.5 10.6885 13.5C10.3778 13.5 10.126 13.2482 10.126 12.9375V7.3125C10.126 7.00184 10.3778 6.75 10.6885 6.75ZM5.0516 13.85C5.1353 14.715 5.86223 15.375 6.73124 15.375H11.2707C12.1397 15.375 12.8666 14.715 12.9503 13.85L13.8189 4.875H4.18304L5.0516 13.85Z"
                                        fill="#FB5F66"
                                      />
                                    </svg>
                                  </>
                                ) : (
                                  <>
                                    <PlusIconSvg /> Add Links
                                  </>
                                )}
                              </button>
                              {dataToBeSaved && dataToBeSaved.length > 0 && (
                                <button
                                  className={`flex items-center gap-[5px] !rounded-[8px] !border !border-black/10 !bg-white !p-[9px] text-[13px] !text-[#666] ${inProcess ? "pointer-events-none opacity-50" : ""}`}
                                  onClick={() => {
                                    debouncedHandleMultipleRecync();
                                  }}
                                  ref={addLinkBtnRef}
                                >
                                  <svg
                                    width={18}
                                    height={18}
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M15.7709 9.59106C15.6403 11.1299 14.9859 12.5781 13.9162 13.6952C12.8465 14.8123 11.4258 15.5313 9.88988 15.7329C8.35392 15.9344 6.79499 15.6064 5.47175 14.8032C4.14851 14.0001 3.14049 12.7701 2.61492 11.3173C2.08935 9.86448 2.07783 8.27622 2.58227 6.816C3.08671 5.35578 4.07679 4.11137 5.38824 3.28923C6.69969 2.46709 8.25369 2.11664 9.79242 2.29601C11.3311 2.47539 12.7621 3.17381 13.8479 4.27541H11.734C11.5544 4.27541 11.3821 4.34652 11.2552 4.47311C11.1282 4.5997 11.0568 4.77139 11.0568 4.95041C11.0568 5.12943 11.1282 5.30112 11.2552 5.42771C11.3821 5.5543 11.5544 5.62541 11.734 5.62541H14.5392C14.8727 5.62523 15.1924 5.49311 15.4282 5.25808C15.6639 5.02305 15.7965 4.70432 15.7966 4.37193V1.57539C15.7966 1.39637 15.7253 1.22468 15.5983 1.09809C15.4713 0.971507 15.2991 0.900391 15.1195 0.900391C14.9399 0.900391 14.7677 0.971507 14.6407 1.09809C14.5137 1.22468 14.4424 1.39637 14.4424 1.57539V2.97805C13.0805 1.76489 11.3479 1.04517 9.52485 0.935296C7.70178 0.825424 5.89483 1.33182 4.39624 2.37259C2.89766 3.41336 1.79507 4.92765 1.2668 6.67053C0.738527 8.41341 0.815466 10.283 1.48517 11.9769C2.15488 13.6708 3.37819 15.0899 4.95725 16.0048C6.53632 16.9197 8.37881 17.2769 10.1867 17.0185C11.9946 16.7601 13.6623 15.9014 14.9199 14.5811C16.1775 13.2608 16.9516 11.5562 17.117 9.74293C17.1258 9.64893 17.1148 9.55415 17.0847 9.46462C17.0547 9.37509 17.0063 9.29277 16.9426 9.22292C16.8789 9.15307 16.8013 9.09721 16.7147 9.0589C16.6282 9.0206 16.5346 9.00068 16.4399 9.00043C16.2747 8.99844 16.1147 9.05783 15.991 9.16701C15.8674 9.27619 15.7889 9.42736 15.7709 9.59106Z"
                                      fill="#666666"
                                    />
                                  </svg>
                                  {/* Resync Links */}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                        {isUrlTrainingRateLimited ? (
                          <div className="retrain_err sticky left-0 top-0 flex items-center justify-between">
                            <div className="flex items-center gap-[8px]">
                              <IErrIconSvg />
                              <p className="mt-0">
                                {isOld
                                  ? "You have reached your training characters limit."
                                  : fromOutgrow
                                    ? "Some links weren't trained."
                                    : "You don’t have enough credits to train some links. "}
                                {fromOutgrow ? (
                                  <>
                                    {" "}
                                    <span className="font-medium">
                                      Add credits
                                    </span>{" "}
                                    to continue
                                  </>
                                ) : (
                                  " Please upgrade your plan."
                                )}
                              </p>
                            </div>
                            <div className="flex items-center gap-[8px]">
                              <button
                                className="flex items-center gap-[8px]"
                                onClick={() => {
                                  fromOutgrow
                                    ? sendEventToOutgrow({
                                        type: "navigate",
                                        payload: {
                                          route: "/settings/membership",
                                        },
                                      })
                                    : navigate("/settings");
                                  dispatch(userSlice.actions.setSettings(2));
                                }}
                              >
                                {fromOutgrow ? (
                                  "Buy Credits"
                                ) : (
                                  <>
                                    <RetrainBtnIcon /> Upgrade Plan
                                  </>
                                )}
                              </button>
                            </div>
                          </div>
                        ) : (
                          rejectedLinks &&
                          rejectedLinks.length > 0 && (
                            <div className="retrain_err sticky left-0 top-0 flex items-center justify-between">
                              <div className="flex items-center gap-[8px]">
                                <IErrIconSvg />{" "}
                                <p className="mt-0">
                                  <span className="font-medium">
                                    {" "}
                                    {rejectedLinks.length ?? 0} links couldn't
                                    be trained
                                  </span>{" "}
                                  due to formatting errors or accessibility
                                  issues.
                                </p>
                              </div>
                              <div className="flex items-center gap-[8px]">
                                <button
                                  className="flex items-center gap-[8px]"
                                  onClick={() => {
                                    setSelectedStatus({
                                      text: "",
                                      icon: null,
                                    });
                                    retryRejectedLinks(rejectedLinks, "urls");
                                  }}
                                >
                                  {" "}
                                  <RetrainBtnIcon /> Retrain
                                </button>
                                {/* <button>
                              {" "}
                              <DelIcon />{" "}
                            </button> */}
                              </div>
                            </div>
                          )
                        )}

                        <table
                          className={`links_table new-scrollbar w-100 mt-0 flex flex-col overflow-y-auto ${inProcess && "pointer-events-none opacity-50"}`}
                        >
                          <thead className="sticky top-0 z-[1] flex w-full bg-white">
                            <tr>
                              <th className="flex items-center">
                                {paginatedLinks.length > 0 && (
                                  <label className="checkbox-container link-mark mb-0 flex w-[16px] items-center">
                                    <input
                                      className="bot-check h-[unset]"
                                      type="checkbox"
                                      checked={isAllChecked}
                                      id={`checkbox`}
                                      disabled={isPostTrainingDelay}
                                    />
                                    <span
                                      className="mark"
                                      onClick={() => {
                                        handleMasterCheckboxChange();
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                      >
                                        <rect
                                          width="16"
                                          height="16"
                                          rx="5"
                                          fill="#FB5F66"
                                        />
                                        <path
                                          d="M11.6923 4.11088C11.3794 3.90411 10.9616 3.99489 10.7589 4.31353L6.9773 10.2532L5.13304 8.51563C4.85926 8.25774 4.43251 8.2747 4.17942 8.55368C3.92634 8.83243 3.94298 9.26775 4.21677 9.52541L6.63828 11.8068C6.63828 11.8068 6.70779 11.8677 6.73996 11.8891C6.85334 11.9642 6.98067 12 7.10665 12C7.32757 12 7.54421 11.8895 7.67356 11.6864L11.8912 5.06198C12.0941 4.74334 12.005 4.31742 11.6923 4.11088Z"
                                          fill="white"
                                        />
                                      </svg>
                                    </span>
                                  </label>
                                )}
                                <span className="pl-[16px] font-medium">
                                  Links
                                </span>
                              </th>
                              <th>Status</th>
                              <th
                                className={`order_drp relative flex cursor-pointer items-center gap-6 ${isTrainingInProgress ? "pointer-events-none opacity-50" : ""}`}
                                onClick={(e) => {
                                  if (isTrainingInProgress) return;
                                  e.stopPropagation();
                                  toggleDropdowns(
                                    "linkCharacters",
                                    !drpToggle.linkCharacters,
                                  );
                                }}
                                onMouseLeave={() =>
                                  toggleDropdowns("linkCharacters", false)
                                }
                              >
                                <span className="flex items-center gap-[8px] font-medium">
                                  Characters <CharactersIconSvg />
                                </span>

                                {drpToggle.linkCharacters && (
                                  <ul className="status_dropdown_list absolute left-0 top-[50px] z-[1] overflow-hidden rounded-[8px] bg-white shadow-md">
                                    <h4 className="text-left !text-[12px] uppercase !text-[rgba(68,68,68,0.70)]">
                                      Order
                                    </h4>
                                    {order.map((item, index) => (
                                      <li
                                        key={index}
                                        className="flex cursor-pointer items-center gap-[5px] px-4 py-2 hover:bg-gray-200"
                                        onClick={() => {
                                          toggleDropdowns(
                                            "linkCharacters",
                                            false,
                                          );
                                          if (item.text === "Ascending") {
                                            sortByCharactersAscending();
                                          } else {
                                            sortByCharactersDescending();
                                          }
                                        }}
                                      >
                                        {item.iconComponent} {item.text}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </th>

                              <th
                                className={`order_drp relative flex cursor-pointer items-center gap-6 ${isTrainingInProgress ? "pointer-events-none opacity-50" : ""}`}
                                onClick={(e) => {
                                  if (isTrainingInProgress) return;
                                  e.stopPropagation();
                                  toggleDropdowns(
                                    "linkLastSynced",
                                    !drpToggle.linkLastSynced,
                                  );
                                }}
                                onMouseLeave={() =>
                                  toggleDropdowns("linkLastSynced", false)
                                }
                              >
                                <span className="flex items-center gap-[8px] font-medium">
                                  Last-Synced <CharactersIconSvg />
                                </span>

                                {drpToggle.linkLastSynced && (
                                  <ul className="status_dropdown_list absolute left-0 top-[50px] z-[1] overflow-hidden rounded-[8px] bg-white shadow-md">
                                    <h4 className="text-left !text-[12px] uppercase !text-[rgba(68,68,68,0.70)]">
                                      Order
                                    </h4>
                                    {order.map((item, index) => (
                                      <li
                                        key={index}
                                        className="flex cursor-pointer items-center gap-[5px] px-4 py-2 hover:bg-gray-200"
                                        onClick={() => {
                                          toggleDropdowns(
                                            "linkLastSynced",
                                            false,
                                          );
                                          if (item.text === "Ascending") {
                                            sortByLastSyncedAscending();
                                          } else {
                                            sortByLastSyncedDescending();
                                          }
                                        }}
                                      >
                                        {item.iconComponent} {item.text}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </th>
                              <th>Auto-sync</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody
                            className={`grey-scrollbar flex !h-max min-h-[180px] flex-col items-center justify-start ${isUrlTrainingRateLimited || (rejectedLinks && rejectedLinks.length > 0) ? "err_dynamic_height" : "link-dynamic-height"}`}
                          >
                            {showAddLink && (
                              <tr
                                className="add_link_tr w-100 p-relative flex h-[54px] flex-col items-center"
                                ref={addLinkInputRef}
                                tabIndex={-1}
                                onBlur={(e) => {
                                  if (
                                    !e.currentTarget.contains(
                                      e.relatedTarget as Node,
                                    )
                                  ) {
                                    setShowAddLink(false);
                                  }
                                }}
                              >
                                <td className="add_link_input flex items-center gap-6">
                                  <input
                                    ref={focusRef}
                                    type="text"
                                    placeholder="Type or paste your link here..."
                                    value={extraUrl}
                                    onChange={(e) =>
                                      setExtraUrl(e.target.value)
                                    }
                                    onKeyDown={handleTrain}
                                    autoFocus
                                  />
                                  {error && (
                                    <p className="flex items-center gap-[4px] whitespace-nowrap pl-[16px] text-[12px] text-[#fb5f66]">
                                      <svg
                                        width={15}
                                        height={14}
                                        viewBox="0 0 15 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clipPath="url(#clip0_1344_48051)">
                                          <path
                                            d="M14.3029 10.4994L9.35734 1.40823C8.56275 0.0705426 6.62581 0.0687653 5.83016 1.40823L0.884876 10.4994C0.0726023 11.8663 1.05602 13.5972 2.64806 13.5972H12.5393C14.13 13.5972 15.1151 11.8676 14.3029 10.4994ZM7.59375 11.9565C7.14154 11.9565 6.77343 11.5884 6.77343 11.1362C6.77343 10.684 7.14154 10.3159 7.59375 10.3159C8.04596 10.3159 8.41406 10.684 8.41406 11.1362C8.41406 11.5884 8.04596 11.9565 7.59375 11.9565ZM8.41406 8.67529C8.41406 9.1275 8.04596 9.4956 7.59375 9.4956C7.14154 9.4956 6.77343 9.1275 6.77343 8.67529V4.57373C6.77343 4.12152 7.14154 3.75342 7.59375 3.75342C8.04596 3.75342 8.41406 4.12152 8.41406 4.57373V8.67529Z"
                                            fill="#FB5F66"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_1344_48051">
                                            <rect
                                              width={14}
                                              height={14}
                                              fill="white"
                                              transform="translate(0.59375)"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      Invalid Url
                                    </p>
                                  )}
                                  {iscrawling ? (
                                    <div className="rotating-svg">
                                      <TrainingProgressIcon />
                                    </div>
                                  ) : (
                                    <>
                                      <div className="training-btn fx al-cnt gap-6">
                                        <button
                                          className="whitespace-nowrap"
                                          onClick={() =>
                                            fetchExtraUrl(
                                              extraUrl,
                                              "extra",
                                              [],
                                              false,
                                              true,
                                            )
                                          }
                                        >
                                          Train Now
                                        </button>

                                        <span
                                          className="cancel-train cursor-pointer"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setShowAddLink(false);
                                            setError(false);
                                            // Always clear the inputs when closing
                                            setExtraUrl("");
                                            setSearchTerm("");
                                            // Re-filter links with empty search term
                                            filterLinks(
                                              "",
                                              setSearchedLinks,
                                              setPaginatedLinks,
                                              selectedStatus,
                                            );
                                          }}
                                        >
                                          <SourceLinkCloseIcon />
                                        </span>
                                      </div>
                                    </>
                                  )}
                                </td>
                                <td
                                  className={`h-100 p-absolute right-0 flex items-center justify-center gap-10 !px-[10px] !py-[6px]`}
                                ></td>
                              </tr>
                            )}
                            {paginatedLinks.length > 0 ? (
                              paginatedLinks.map((data, index) => {
                                const actualIndex =
                                  (currentPage - 1) * itemsPerPage + index;
                                return (
                                  <tr
                                    className={`w-100 flex flex-col ${inProcess ? "pointer-events-none opacity-50" : ""}`}
                                    key={actualIndex}
                                  >
                                    <td className="flex items-center">
                                      <label className="checkbox-container link-mark mb-0 flex w-[16px] items-center">
                                        <input
                                          className="bot-check h-[unset]"
                                          type="checkbox"
                                          id={`checkbox_${data.url}`}
                                          checked={checkedState[data.url]}
                                          disabled={
                                            isPostTrainingDelay ||
                                            data.status === "In Progress"
                                          }
                                        />
                                        <span
                                          className="mark !w-[18px]"
                                          onClick={() =>
                                            handleCheckboxChange(data)
                                          }
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                          >
                                            <rect
                                              width="16"
                                              height="16"
                                              rx="5"
                                              fill="#FB5F66"
                                            />
                                            <path
                                              d="M11.6923 4.11088C11.3794 3.90411 10.9616 3.99489 10.7589 4.31353L6.9773 10.2532L5.13304 8.51563C4.85926 8.25774 4.43251 8.2747 4.17942 8.55368C3.92634 8.83243 3.94298 9.26775 4.21677 9.52541L6.63828 11.8068C6.63828 11.8068 6.70779 11.8677 6.73996 11.8891C6.85334 11.9642 6.98067 12 7.10665 12C7.32757 12 7.54421 11.8895 7.67356 11.6864L11.8912 5.06198C12.0941 4.74334 12.005 4.31742 11.6923 4.11088Z"
                                              fill="white"
                                            />
                                          </svg>
                                        </span>
                                      </label>
                                      <span
                                        className="fx trainedLinksUrl ml-[16px] gap-8 overflow-hidden whitespace-nowrap"
                                        title={data.title ?? data.url}
                                        onMouseEnter={(e) => {
                                          const container = e.currentTarget;
                                          const inner = container.querySelector(
                                            ".scrolling-text",
                                          ) as HTMLElement | null;
                                          if (inner) {
                                            const scrollDistance =
                                              inner.scrollWidth -
                                              container.offsetWidth;
                                            if (scrollDistance > 0) {
                                              // Set a fixed speed of 100 pixels per second
                                              const speed = 100; // pixels per second
                                              const duration =
                                                scrollDistance / speed;
                                              inner.style.transition = `transform ${duration}s linear`;
                                              inner.style.transform = `translateX(-${scrollDistance}px)`;
                                            }
                                          }
                                        }}
                                        onMouseLeave={(e) => {
                                          const container = e.currentTarget;
                                          const inner = container.querySelector(
                                            ".scrolling-text",
                                          ) as HTMLElement | null;
                                          if (inner) {
                                            inner.style.transition =
                                              "transform 0.3s ease-out";
                                            inner.style.transform =
                                              "translateX(0)";
                                          }
                                        }}
                                      >
                                        <div className="scrolling-text flex items-center gap-2 whitespace-nowrap">
                                          {data?.url?.includes("youtu") && (
                                            <YoutubeIcon />
                                          )}
                                          <span>{data.title ?? data.url}</span>
                                        </div>
                                      </span>
                                    </td>
                                    <td
                                      className={`flex items-center gap-[6px] whitespace-nowrap ${data?.status === "In Progress" && "rotating-svg"} ${data?.status === "Re-syncing" && "resyncing-svg"}`}
                                    >
                                      {
                                        statuses.find(
                                          (item) => item.text === data.status,
                                        )?.iconComponent
                                      }
                                      {data.status}
                                    </td>

                                    <td>
                                      {useFormatNumber(
                                        data.characterCount ??
                                          data.transcript?.length ??
                                          0,
                                      )}
                                    </td>
                                    <td>
                                      {isNaN(Number(data.lastSyncTime)) ||
                                      !data.lastSyncTime
                                        ? "..."
                                        : moment(
                                            Number(data.lastSyncTime),
                                          ).fromNow()}{" "}
                                      <br></br>
                                      {/* {new Date(data.lastSyncTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })} */}
                                    </td>
                                    <td
                                      className={`cp relative flex items-center justify-between ${paginatedLinks.length > 2 ? "upperDrp" : ""}`}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDropdowns(
                                          actualIndex,
                                          "syncTime",
                                          !dropdowns[actualIndex]?.syncTime,
                                        );
                                      }}
                                      onMouseLeave={() =>
                                        handleDropdowns(
                                          actualIndex,
                                          "syncTime",
                                          false,
                                        )
                                      }
                                    >
                                      {syncTimes[data.url] ||
                                        syncTimeMapping[
                                          data.syncIntervalDays
                                        ] ||
                                        "Off"}

                                      <span
                                        ref={(el) => {
                                          if (!dropdownRef.current) {
                                            dropdownRef.current = {};
                                          }
                                          dropdownRef.current[
                                            `syncTime-${actualIndex}`
                                          ] = el;
                                        }}
                                        className={`transition-transform duration-300 ${
                                          dropdowns[actualIndex]?.syncTime
                                            ? "rotate-180"
                                            : ""
                                        }`}
                                      >
                                        <DownArrIconSvg />
                                      </span>

                                      {dropdowns[actualIndex]?.syncTime &&
                                        createPortal(
                                          <ul
                                            id={`dropdown-syncTime-${actualIndex}`}
                                            className={`status_dropdown_list absolute z-10 overflow-hidden rounded-[8px] opacity-100 transition-opacity duration-200`}
                                            style={{
                                              top: `${dropdownPosition.top}px`,
                                              left: `${dropdownPosition.left}px`,
                                              zIndex: 999,
                                              ...(fromOutgrow && {
                                                fontFamily:
                                                  '"Ubuntu", sans-serif',
                                              }),
                                            }}
                                          >
                                            {Object.values(syncTimeMapping).map(
                                              (item, idx) => (
                                                <li
                                                  key={idx}
                                                  className="cursor-pointer text-[14px] !text-[#444]"
                                                  onClick={(e) => {
                                                    e.stopPropagation();

                                                    handleSyncTimeChange(
                                                      actualIndex,
                                                      item,
                                                      data,
                                                    );
                                                  }}
                                                >
                                                  {item}
                                                </li>
                                              ),
                                            )}
                                          </ul>,
                                          document.getElementById(
                                            "dropdown-portal",
                                          ) as HTMLElement,
                                        )}
                                    </td>

                                    <td className="flex items-center justify-between">
                                      <span
                                        className={`resync_icon relative ${data?.status === "Re-syncing" && "resyncing-svg"}`}
                                        onClick={() => {
                                          if (
                                            data?.status === "Re-syncing" ||
                                            data?.status === "In Progress"
                                          )
                                            return;
                                          handleResync(data, data.sourceType);
                                        }}
                                      >
                                        <svg
                                          className="cursor-pointer"
                                          width={17}
                                          height={16}
                                          viewBox="0 0 17 16"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g clipPath="url(#clip0_841_2984)">
                                            <g opacity={0.5}>
                                              <path
                                                d="M8.40664 13.6994C6.83512 13.6994 5.41016 13.0601 4.378 12.0279L5.88744 10.5186C6.11592 10.2901 5.95416 9.89941 5.63112 9.89941H1.45832C1.28548 9.89941 1.11973 9.96807 0.997513 10.0903C0.8753 10.2125 0.806641 10.3783 0.806641 10.5511V14.7239C0.806641 15.0471 1.19736 15.2087 1.42584 14.9802L3.03512 13.3709C4.41144 14.7469 6.31128 15.5994 8.40664 15.5994C12.3441 15.5994 15.5918 12.5895 15.9698 8.74981C16.0095 8.34661 15.6854 7.99941 15.2802 7.99941H14.7602C14.4052 7.99941 14.1114 8.26853 14.0729 8.62149C13.762 11.4729 11.3394 13.6994 8.40664 13.6994ZM8.40664 0.399414C4.46904 0.399414 1.22152 3.40917 0.843441 7.24901C0.803761 7.65221 1.12792 7.99941 1.53304 7.99941H2.05304C2.40808 7.99941 2.70184 7.73029 2.7404 7.37733C3.05128 4.52597 5.47384 2.29941 8.40664 2.29941C9.97816 2.29941 11.4031 2.93877 12.4353 3.97077L10.9258 5.48021C10.6974 5.70869 10.8591 6.09941 11.1822 6.09941H15.355C15.5278 6.09941 15.6936 6.03076 15.8158 5.90854C15.938 5.78633 16.0066 5.62057 16.0066 5.44773V1.27493C16.0066 0.951734 15.6159 0.790134 15.3874 1.01861L13.7782 2.62789C12.4018 1.25189 10.502 0.399414 8.40664 0.399414Z"
                                                fill="#6A6A65"
                                              />
                                            </g>
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_841_2984">
                                              <rect
                                                width={16}
                                                height={16}
                                                fill="white"
                                                transform="translate(0.40625)"
                                              />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                        <p className="sm-tooltip flex-cnt">
                                          <span className="sm-tooltip_text">
                                            {" "}
                                            Resync
                                          </span>
                                        </p>
                                      </span>
                                      <span
                                        ref={(el) => {
                                          if (!dropdownRef.current) {
                                            dropdownRef.current = {};
                                          }
                                          dropdownRef.current[
                                            `linkAction-${actualIndex}`
                                          ] = el;
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDropdowns(
                                            actualIndex,
                                            "linkAction",
                                            !dropdowns[actualIndex]?.linkAction,
                                          );
                                        }}
                                        onMouseLeave={() =>
                                          handleDropdowns(
                                            actualIndex,
                                            "linkAction",
                                            false,
                                          )
                                        }
                                        className={`files_action_drp cp relative flex h-[30px] w-[30px] items-center justify-center ${paginatedLinks.length > 2 ? "upper_drp" : ""} ${dropdowns[actualIndex]?.linkAction ? "show-before" : ""}`}
                                      >
                                        <svg
                                          className="cursor-pointer"
                                          width={17}
                                          height={16}
                                          viewBox="0 0 17 16"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g clipPath="url(#clip0_841_17)">
                                            <path
                                              d="M8.40494 3.33331C9.32541 3.33331 10.0716 2.58713 10.0716 1.66666C10.0716 0.746187 9.32541 0 8.40494 0C7.48447 0 6.73828 0.746187 6.73828 1.66666C6.73828 2.58713 7.48447 3.33331 8.40494 3.33331Z"
                                              fill="#444444"
                                            />
                                            <path
                                              d="M8.40494 9.66534C9.32541 9.66534 10.0716 8.91916 10.0716 7.99869C10.0716 7.07822 9.32541 6.33203 8.40494 6.33203C7.48447 6.33203 6.73828 7.07822 6.73828 7.99869C6.73828 8.91916 7.48447 9.66534 8.40494 9.66534Z"
                                              fill="#444444"
                                            />
                                            <path
                                              d="M8.40494 16.0013C9.32541 16.0013 10.0716 15.2551 10.0716 14.3346C10.0716 13.4142 9.32541 12.668 8.40494 12.668C7.48447 12.668 6.73828 13.4142 6.73828 14.3336C6.73828 15.2541 7.48447 16.0013 8.40494 16.0013Z"
                                              fill="#444444"
                                            />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_841_17">
                                              <rect
                                                width={16}
                                                height={16}
                                                fill="white"
                                                transform="translate(0.40625)"
                                              />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                        {dropdowns[actualIndex]?.linkAction &&
                                          createPortal(
                                            <ul
                                              id={`dropdown-linkAction-${actualIndex}`}
                                              className={`status_dropdown_list absolute z-10 !w-[142px] overflow-hidden rounded-[8px]`}
                                              style={{
                                                top: `${dropdownPosition.top}px`,
                                                left: `${dropdownPosition.left}px`,
                                                zIndex: 999,
                                                ...(fromOutgrow && {
                                                  fontFamily:
                                                    '"Ubuntu", sans-serif',
                                                }),
                                              }}
                                            >
                                              <li
                                                // className="flex cursor-pointer items-center gap-[6px]"
                                                className={`flex cursor-pointer items-center gap-[6px] text-[14px] text-[#444] ${data?.status === "In Progress" || data?.status === "Link Rejected" ? "pointer-events-none opacity-50" : ""}`}
                                                onClick={() => {
                                                  if (
                                                    data?.status ===
                                                      "In Progress" ||
                                                    data?.status ===
                                                      "Re-syncing"
                                                  )
                                                    return;
                                                  handleViewDetails(
                                                    data.url,
                                                    data.status,
                                                    data.content || "",
                                                    actualIndex,
                                                    "url",
                                                  );
                                                  handleDropdowns(
                                                    actualIndex,
                                                    "linkAction",
                                                    false,
                                                  );
                                                }}
                                              >
                                                <ViewDetailsIcon />
                                                View Details
                                              </li>
                                              <li
                                                className={`flex cursor-pointer items-center gap-[6px] text-[14px] text-[#444] ${data?.status === "In Progress" || data?.status === "Link Rejected" ? "pointer-events-none opacity-50" : ""}`}
                                                onClick={() => {
                                                  if (
                                                    data?.status ===
                                                      "In Progress" ||
                                                    data?.status ===
                                                      "Re-syncing"
                                                  )
                                                    return;
                                                  debouncedHandleDeleteUrl(
                                                    [data],
                                                    actualIndex,
                                                    data?.sourceType,
                                                  );
                                                  handleDropdowns(
                                                    actualIndex,
                                                    "linkAction",
                                                    false,
                                                  );
                                                }}
                                              >
                                                <DelIconSvg />
                                                Delete
                                              </li>
                                            </ul>,
                                            document.getElementById(
                                              "dropdown-portal",
                                            ) as HTMLElement,
                                          )}
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <div className="no_links_fetched pd-30 h-100 grid place-items-center">
                                <img
                                  src="https://dlvkyia8i4zmz.cloudfront.net/7eUKmJsvR0OTNIC4DKVQ_1.svg"
                                  alt="no links fetched"
                                />
                              </div>
                            )}
                          </tbody>
                        </table>
                        <div className="border-t-[rgba(0, 0, 0, 0.10)] flex h-[60px] w-full items-center justify-between overflow-hidden rounded-b-[10px] border-t bg-[#f9f9f9] px-[30px] py-[16px]">
                          <Pagination
                            currentPage={currentPage}
                            totalPages={Math.ceil(
                              searchedLinks.length / itemsPerPage,
                            )}
                            totalItems={searchedLinks.length}
                            itemsPerPage={itemsPerPage}
                            onPageChange={handlePageChange}
                            showFirstLast={true}
                            showItemsInfo={true}
                          />
                        </div>
                      </>
                    ) : (
                      <div className="no_links_fetched pd-30 h-100 grid place-items-center">
                        <img
                          src="https://dlvkyia8i4zmz.cloudfront.net/7eUKmJsvR0OTNIC4DKVQ_1.svg"
                          alt="no links fetched"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </motion.div>
          )}
          {selectedSourceTab == "native_apps" && (
            <NativeApps
              characterUsed={characterUsed}
              characterLimit={characterLimit}
              inProcess={inProcess}
              deleteTrainDocument={deleteTrainDocument}
              openGooglePicker={openGooglePicker}
              botData={botData}
              isRetraining={isRetraining}
              setSelectedStatus={setSelectedStatus}
              retryRejectedLinks={retryRejectedLinks}
              isPostTrainingDelay={isPostTrainingDelay}
              handleResync={handleResync}
              handleDropdowns={handleDropdowns}
              handleViewDetails={handleViewDetails}
              handleFileRemove={handleFileRemove}
              dropdowns={dropdowns}
              isOld={isOld}
            />
          )}

          {selectedSourceTab == "upload_source" && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
              className={`uploadFile fx-d-col h-100 upload-source-wrapper relative flex ${files?.length || botData.dataSources?.documents?.length ? "" : "pb-[20px]"}`}
            >
              <h3 className="!mb-[10px] flex items-center gap-[10px] text-left">
                Upload Data
                {isOld && (
                  <div className="character-count-wrapper flex items-center gap-[10px]">
                    <span className="!ms-[0px] h-[24px] w-[1px] bg-[#666] opacity-[0.3]"></span>
                    <p
                      className={`character-count pointer relative z-[5] flex items-center gap-[4px] rounded-[5px] px-[8px] py-[6px] text-[13px] font-medium capitalize leading-normal ${useFormatNumber(characterUsed) === useFormatNumber(characterLimit) ? "bg-[#FFE8E9] text-[#fb5f66]" : "bg-[#FEF2CC] text-[#9A6815]"} `}
                    >
                      <CharacterLimitIcon
                        color={
                          useFormatNumber(characterUsed) ===
                          useFormatNumber(characterLimit)
                            ? "#fb5f66"
                            : "#9A6815"
                        }
                      />
                      {characterLimit === 0 ? (
                        <div className="yellow-loader"></div>
                      ) : (
                        `${useFormatNumber(characterUsed)} / ${useFormatNumber(characterLimit)}`
                      )}
                      <div className="none absolute left-[0] top-[35px] z-[1] w-[280px] cursor-default flex-col items-center gap-[10px] rounded-[8px] bg-[#222] p-[10px]">
                        {useFormatNumber(characterUsed) ===
                        useFormatNumber(characterLimit) ? (
                          <p className="text-center text-[12px] font-normal normal-case not-italic leading-[17px] text-[#fb5f66]">
                            Your current plan doesn't support more than
                            <b className="font-medium">
                              {" "}
                              {useFormatNumber(characterLimit)} Characters.{" "}
                            </b>
                            {plan.name !== "Professional"
                              ? "Upgrade to the Professional plan to unlock this feature."
                              : "If you want more, you have to buy the add-on."}
                          </p>
                        ) : (
                          <p className="text-center text-[12px] font-normal normal-case not-italic leading-[17px] text-white/80">
                            Agents can use a maximum of <br />
                            <b className="font-medium">
                              {useFormatNumber(characterLimit)} Characters
                            </b>
                            , including link content. Anything over that limit
                            won't be used.
                          </p>
                        )}
                        {plan.name !== "Professional" ? (
                          <button
                            className="pointer h-[30px] w-full rounded-[8px] bg-[#fb5f66] text-[12px] font-normal leading-normal text-white"
                            onClick={() => {
                              setBuyAddOn(false);
                              setLeaveModal(true);
                            }}
                          >
                            Upgrade Plan
                          </button>
                        ) : (
                          <button
                            className="pointer h-[30px] w-full rounded-[8px] bg-[#fb5f66] text-[12px] font-normal leading-normal text-white"
                            onClick={() => {
                              setBuyAddOn(true);
                              setLeaveModal(true);
                            }}
                          >
                            Buy add-on
                          </button>
                        )}
                      </div>
                    </p>
                  </div>
                )}
              </h3>
              <div className="file-uploads-inner fx w-100 fx-d-col gap-20 overflow-auto">
                <input
                  type="file"
                  name="file-input"
                  id="file-input"
                  className="file-input__input"
                  accept=".pdf,.txt,.docx,.xlsx,.csv,.md"
                  multiple={true}
                  value=""
                  onChange={(event) => {
                    onFileUpload(event);
                  }}
                  disabled={showProgress}
                />
                <label htmlFor="file-input" className="upload-box-wrapper">
                  <div
                    className="upload-box flex-cnt fx-d-col w-auto"
                    onMouseEnter={() => setIsStopped(false)}
                    onMouseLeave={() => setIsStopped(true)}
                  >
                    {!showProgress && (
                      <div className="upload-files flex-cnt fx-d-col">
                        <div className="upload-icon-frame">
                          <Lottie
                            options={defaultOptions}
                            height={150}
                            width={150}
                            isStopped={isStopped}
                          />
                        </div>
                        <motion.span
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.85 }}
                          className="browse-btn fw-500 mt-10"
                        >
                          Upload File
                        </motion.span>
                        <p className="file-size">{`Max File Size: ${size} MB`}</p>
                        <div className="uploadDetails fx">
                          <p>
                            Supported formats: PDF, DOCX , TXT , MD , XLSX, CSV
                          </p>
                        </div>
                      </div>
                    )}
                    {showProgress && (
                      <div className="progress-bar flex-cnt fx-d-col">
                        <ProgressBar progress={uploadProgress} />
                      </div>
                    )}
                  </div>
                </label>
                {files?.length > 0 && (
                  <div className="fx-d-col flex h-max">
                    <h4 className="tabs_inner_head mb-10 font-medium text-text-clr">
                      Uploaded Data
                    </h4>
                    {files?.length || botData.dataSources?.documents?.length ? (
                      <div className="uploadedFilegrid h-max">
                        <table className="mt-0 overflow-hidden">
                          <thead
                            className={`sticky top-0 h-[54px] bg-[#F2F2F2] ${files.length > 5 ? "pr-[9.5px]" : ""}`}
                          >
                            <th>File Name</th>
                            <th>Size</th>
                            <th>Character</th>
                            <th>Action</th>
                          </thead>
                          <tbody
                            className={`grey-scrollbar ${files.length < 5 ? "overflow-hidden" : ""} flex max-h-[278px] flex-col overflow-auto bg-white`}
                          >
                            <AnimatePresence>
                              {files?.map((file, index) => (
                                <motion.tr
                                  key={file.id || index}
                                  className={`${files.length > 10 ? "no-right-border" : ""}`}
                                  initial={{ opacity: 0, height: 0 }}
                                  animate={{ opacity: 1, height: "auto" }}
                                  exit={{
                                    opacity: 0,
                                    height: 0,
                                    transition: { duration: 0.5 },
                                  }}
                                  layout
                                >
                                  <td className="w-100 overflow-hidden text-ellipsis whitespace-nowrap">
                                    <span
                                      className="fx trainedLinksUrl gap-8 overflow-hidden whitespace-nowrap"
                                      onMouseEnter={(e) => {
                                        const container = e.currentTarget;
                                        const inner = container.querySelector(
                                          ".scrolling-text",
                                        ) as HTMLElement | null;
                                        if (inner) {
                                          const scrollDistance =
                                            inner.scrollWidth -
                                            container.offsetWidth;
                                          if (scrollDistance > 0) {
                                            // Set a fixed speed of 100 pixels per second
                                            const speed = 100; // pixels per second
                                            const duration =
                                              scrollDistance / speed;
                                            inner.style.transition = `transform ${duration}s linear`;
                                            inner.style.transform = `translateX(-${scrollDistance}px)`;
                                          }
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        const container = e.currentTarget;
                                        const inner = container.querySelector(
                                          ".scrolling-text",
                                        ) as HTMLElement | null;
                                        if (inner) {
                                          inner.style.transition =
                                            "transform 0.3s ease-out";
                                          inner.style.transform =
                                            "translateX(0)";
                                        }
                                      }}
                                    >
                                      <div className="scrolling-text flex items-center gap-2 whitespace-nowrap">
                                        <span title={file.title}>
                                          {" "}
                                          {file.title}
                                        </span>
                                      </div>
                                    </span>
                                  </td>

                                  {file?.size && (
                                    <td className="uploadDetails fx mt-0">
                                      <p className="!text-[14px] !text-[#444]">
                                        {file?.size / (1024 * 1024) >= 0.01
                                          ? (
                                              file?.size /
                                              (1024 * 1024)
                                            ).toFixed(2) + " MB"
                                          : (file?.size / 1024).toFixed(2) +
                                            " KB"}
                                      </p>
                                    </td>
                                  )}

                                  {file?.text && (
                                    <td className="uploadDetails fx mt-0">
                                      <p className="!text-[14px] !text-[#444]">
                                        {file
                                          ? "Post-training"
                                          : file.text.length}
                                      </p>
                                    </td>
                                  )}
                                  <td className="flex items-center justify-center">
                                    <svg
                                      onClick={() => onFileRemove(index)}
                                      className="cursor-pointer"
                                      width="32"
                                      height="32"
                                      viewBox="0 0 32 32"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        x="0.302734"
                                        width="30.7265"
                                        height="32"
                                        rx="8"
                                        fill="#FFE0E1"
                                      />
                                      <path
                                        d="M21.393 11.9088C21.176 11.9088 20.9679 11.995 20.8145 12.1485C20.661 12.3019 20.5748 12.51 20.5748 12.727V21.8828C20.5514 22.2965 20.3654 22.6842 20.0574 22.9614C19.7493 23.2386 19.3443 23.3829 18.9304 23.3628H12.4016C11.9877 23.3829 11.5826 23.2386 11.2746 22.9614C10.9666 22.6842 10.7806 22.2965 10.7572 21.8828V12.727C10.7572 12.51 10.671 12.3019 10.5175 12.1485C10.3641 11.995 10.156 11.9088 9.93901 11.9088C9.72203 11.9088 9.51393 11.995 9.3605 12.1485C9.20707 12.3019 9.12087 12.51 9.12087 12.727V21.8828C9.14423 22.7306 9.5026 23.5345 10.1175 24.1186C10.7324 24.7027 11.5538 25.0193 12.4016 24.9991H18.9304C19.7782 25.0193 20.5996 24.7027 21.2145 24.1186C21.8294 23.5345 22.1878 22.7306 22.2111 21.8828V12.727C22.2111 12.51 22.1249 12.3019 21.9715 12.1485C21.8181 11.995 21.61 11.9088 21.393 11.9088ZM22.2111 9.45442H18.9386V7.81814C18.9386 7.60116 18.8524 7.39306 18.6989 7.23963C18.5455 7.0862 18.3374 7 18.1204 7H13.2116C12.9946 7 12.7865 7.0862 12.6331 7.23963C12.4796 7.39306 12.3934 7.60116 12.3934 7.81814V9.45442H9.12087C8.90389 9.45442 8.69579 9.54062 8.54236 9.69405C8.38893 9.84748 8.30273 10.0556 8.30273 10.2726C8.30273 10.4895 8.38893 10.6976 8.54236 10.8511C8.69579 11.0045 8.90389 11.0907 9.12087 11.0907H22.2111C22.4281 11.0907 22.6362 11.0045 22.7896 10.8511C22.9431 10.6976 23.0293 10.4895 23.0293 10.2726C23.0293 10.0556 22.9431 9.84748 22.7896 9.69405C22.6362 9.54062 22.4281 9.45442 22.2111 9.45442ZM14.0297 9.45442V8.63628H17.3023V9.45442H14.0297Z"
                                        fill="#FB5F66"
                                      />
                                      <path
                                        opacity="0.5"
                                        d="M14.8472 20.09V14.3631C14.8472 14.1461 14.761 13.938 14.6076 13.7845C14.4542 13.6311 14.2461 13.5449 14.0291 13.5449C13.8121 13.5449 13.604 13.6311 13.4506 13.7845C13.2971 13.938 13.2109 14.1461 13.2109 14.3631V20.09C13.2109 20.307 13.2971 20.5151 13.4506 20.6686C13.604 20.822 13.8121 20.9082 14.0291 20.9082C14.2461 20.9082 14.4542 20.822 14.6076 20.6686C14.761 20.5151 14.8472 20.307 14.8472 20.09ZM18.1198 20.09V14.3631C18.1198 14.1461 18.0336 13.938 17.8802 13.7845C17.7267 13.6311 17.5186 13.5449 17.3016 13.5449C17.0847 13.5449 16.8766 13.6311 16.7231 13.7845C16.5697 13.938 16.4835 14.1461 16.4835 14.3631V20.09C16.4835 20.307 16.5697 20.5151 16.7231 20.6686C16.8766 20.822 17.0847 20.9082 17.3016 20.9082C17.5186 20.9082 17.7267 20.822 17.8802 20.6686C18.0336 20.5151 18.1198 20.307 18.1198 20.09Z"
                                        fill="#FB5F66"
                                      />
                                    </svg>
                                  </td>
                                </motion.tr>
                              ))}
                            </AnimatePresence>
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="uploadedFile h-100">
                        <div className="url-crawl ai-info-wrapper flex-cnt fx-d-col no-mt h-100">
                          <NoFilesIcon />
                          <h4>No file to show</h4>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="border-[rgba(102, 102, 102, 0.20)] mt-20 flex h-max flex-col border-t pt-20">
                  <h2 className="text-[16px] font-medium text-text-clr">
                    Trained Files
                  </h2>
                  <div className="trained_links_wrapper files_table_wrapper p-relative new-scrollbar mt-10">
                    {trainedFiles?.length ||
                    botData.aiSource?.documents?.length ? (
                      <>
                        <div className="table_actions sticky left-0 top-0 z-[2] flex items-center justify-between gap-10 bg-[#f9f9f9] px-[20px] py-3">
                          <div className="flex items-center gap-10">
                            <div className="search_div border-[rgba(0, 0, 0, 0.10)] h[44px] flex w-[300px] items-center gap-10 rounded-[10px] border border-solid bg-white px-[16px] py-[13px]">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={15}
                                height={14}
                                viewBox="0 0 15 14"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_190_16528)">
                                  <path
                                    d="M5.60625 0C6.98538 0 8.30802 0.547855 9.28321 1.52304C10.2584 2.49823 10.8063 3.82087 10.8063 5.2C10.8063 6.488 10.3342 7.672 9.55825 8.584L9.77425 8.8H10.4062L14.4062 12.8L13.2063 14L9.20625 10V9.368L8.99025 9.152C8.04669 9.95742 6.84682 10.3999 5.60625 10.4C4.22712 10.4 2.90448 9.85215 1.92929 8.87696C0.954105 7.90177 0.40625 6.57913 0.40625 5.2C0.40625 3.82087 0.954105 2.49823 1.92929 1.52304C2.90448 0.547855 4.22712 0 5.60625 0ZM5.60625 1.6C3.60625 1.6 2.00625 3.2 2.00625 5.2C2.00625 7.2 3.60625 8.8 5.60625 8.8C7.60625 8.8 9.20625 7.2 9.20625 5.2C9.20625 3.2 7.60625 1.6 5.60625 1.6Z"
                                    fill="#444444"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_190_16528">
                                    <rect
                                      width={14}
                                      height={14}
                                      fill="white"
                                      transform="translate(0.40625)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <input
                                type="text"
                                placeholder="Search File"
                                className="h-[unset] border-none bg-transparent p-0 outline-none"
                                value={fileSearchQuery}
                                onChange={handleSearchFiles}
                              />
                            </div>

                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                const rect =
                                  e.currentTarget.getBoundingClientRect();
                                const viewportHeight = window.innerHeight;
                                const spaceBelow = viewportHeight - rect.bottom;
                                const maxHeight = Math.min(
                                  spaceBelow - 20,
                                  300,
                                ); // 20px padding from viewport edge
                                setDropdownPosition({
                                  top: rect.bottom + window.scrollY,
                                  left: rect.left + window.scrollX,
                                  width: rect.width,
                                  maxHeight: maxHeight > 50 ? maxHeight : 150,
                                });
                                toggleDropdowns(
                                  "fileStatus",
                                  !drpToggle.fileStatus,
                                );
                              }}
                              onMouseLeave={() =>
                                toggleDropdowns("fileStatus", false)
                              }
                              className="status_dropdown statuses_drp cp border-[rgba(0, 0, 0, 0.10)] relative flex !h-[44px] w-max items-center justify-between gap-[10px] rounded-[10px] border border-solid bg-white px-[16px] py-[12px]"
                            >
                              {selectedFileStatus.text ? (
                                <span className="flex items-center gap-[6px]">
                                  {selectedFileStatus.icon}{" "}
                                  {selectedFileStatus.text}
                                </span>
                              ) : (
                                "All Statuses"
                              )}
                              <span
                                className={`transition-transform duration-300 ${drpToggle.fileStatus ? "rotate-180" : "rotate-0"}`}
                              >
                                <DownArrIconSvg />
                              </span>

                              {drpToggle.fileStatus &&
                                createPortal(
                                  <ul
                                    className="status_dropdown_list trained_data-statuses grey-scrollbar absolute z-[999] overflow-auto rounded-[8px]"
                                    ref={dropdownRef}
                                    style={{
                                      top: `${dropdownPosition.top}px`,
                                      left: `${dropdownPosition.left}px`,
                                      maxHeight: `${dropdownPosition.maxHeight}px`,
                                      ...(fromOutgrow && {
                                        fontFamily: '"Ubuntu", sans-serif',
                                      }),
                                    }}
                                    onMouseLeave={() =>
                                      toggleDropdowns("fileStatus", false)
                                    }
                                  >
                                    {statuses.map((item, index) => {
                                      return (
                                        <li
                                          key={index}
                                          className="flex cursor-pointer items-center gap-[6px]"
                                          onClick={() => {
                                            handleFileStatusChange(item);
                                            toggleDropdowns(
                                              "fileStatus",
                                              false,
                                            );
                                          }}
                                        >
                                          {item.iconComponent}
                                          {item.text}
                                        </li>
                                      );
                                    })}
                                  </ul>,
                                  document.getElementById(
                                    "dropdown-portal",
                                  ) as HTMLElement,
                                )}
                            </div>
                          </div>
                          <div className="flex items-center gap-10">
                            <span
                              className={`deleteFetchedUrlBtn fx enabled al-cnt gap-8 ${!selectedIds.length ? "pointer-events-none opacity-50" : ""}`}
                              onClick={() =>
                                handleFileRemove(
                                  deleteMultipleTrainDocument,
                                  [],
                                )
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M15.4382 3.5C15.4382 2.94772 14.9905 2.5 14.4382 2.5H11.9208C11.4996 1.30491 10.372 0.504062 9.10483 0.5H7.10483C5.83767 0.504062 4.71008 1.30491 4.28883 2.5H1.77148C1.2192 2.5 0.771484 2.94772 0.771484 3.5C0.771484 4.05228 1.2192 4.5 1.77148 4.5H2.10483V12.8333C2.10483 14.8584 3.74645 16.5 5.77148 16.5H10.4381C12.4632 16.5 14.1048 14.8584 14.1048 12.8333V4.5H14.4382C14.9905 4.5 15.4382 4.05228 15.4382 3.5ZM12.1048 12.8333C12.1048 13.7538 11.3586 14.5 10.4382 14.5H5.77148C4.85102 14.5 4.10483 13.7538 4.10483 12.8333V4.5H12.1048V12.8333ZM6.43774 12.499C6.99003 12.499 7.43774 12.0513 7.43774 11.499V7.49902C7.43774 6.94674 6.99003 6.49902 6.43774 6.49902C5.88546 6.49902 5.43774 6.94674 5.43774 7.49902V11.499C5.43774 12.0513 5.88546 12.499 6.43774 12.499ZM10.7722 11.499C10.7722 12.0513 10.3245 12.499 9.77222 12.499C9.21994 12.499 8.77222 12.0513 8.77222 11.499V7.49902C8.77222 6.94674 9.21994 6.49902 9.77222 6.49902C10.3245 6.49902 10.7722 6.94674 10.7722 7.49902V11.499Z"
                                  fill="#666666"
                                />
                              </svg>
                              Delete Files
                            </span>
                          </div>
                        </div>
                        {isFileTrainingRateLimited ? (
                          <div className="retrain_err sticky left-0 top-0 flex items-center justify-between">
                            <div className="flex items-center gap-[8px]">
                              <IErrIconSvg />
                              <p className="mt-0">
                                {isOld
                                  ? "You have reached your training characters limit."
                                  : "You don’t have enough credits to train some files. "}
                                Please upgrade your plan.
                              </p>
                            </div>
                            <div className="flex items-center gap-[8px]">
                              <button
                                className="flex items-center gap-[8px]"
                                onClick={() => {
                                  fromOutgrow
                                    ? sendEventToOutgrow({
                                        type: "navigate",
                                        payload: {
                                          route: "/settings/membership",
                                        },
                                      })
                                    : navigate("/settings");
                                  dispatch(userSlice.actions.setSettings(2));
                                }}
                              >
                                <RetrainBtnIcon /> Upgrade Plan
                              </button>
                            </div>
                          </div>
                        ) : (
                          rejectedFiles &&
                          rejectedFiles.length > 0 && (
                            <div className="retrain_err sticky left-0 top-0 flex items-center justify-between">
                              <div className="flex items-center gap-[8px]">
                                <IErrIconSvg />{" "}
                                <p className="mt-0">
                                  <span className="font-medium">
                                    {" "}
                                    {rejectedFiles.length ?? 0} files couldn't
                                    be trained
                                  </span>{" "}
                                  due to formatting errors or accessibility
                                  issues.
                                </p>
                              </div>
                              <div className="flex items-center gap-[8px]">
                                {isRetraining ? (
                                  <div className="rotating-svg">
                                    <TrainingProgressIcon />
                                  </div>
                                ) : (
                                  <button
                                    className="flex items-center gap-[8px]"
                                    onClick={() => {
                                      setSelectedStatus({
                                        text: "",
                                        icon: null,
                                      });
                                      retryRejectedLinks(
                                        rejectedFiles,
                                        "documents",
                                      );
                                    }}
                                  >
                                    {" "}
                                    <RetrainBtnIcon /> Retrain
                                  </button>
                                )}
                                {/* <button>
                          {" "}
                          <DelIcon />{" "}
                        </button> */}
                              </div>
                            </div>
                          )
                        )}

                        <table
                          className={`links_table new-scrollbar w-100 mt-0 flex flex-col overflow-y-auto ${inProcess && "pointer-events-none opacity-50"}`}
                        >
                          <thead className="sticky top-0 z-[1] flex w-full bg-white">
                            <tr>
                              <th className="flex items-center">
                                {paginatedFiles?.length > 0 && (
                                  <label className="checkbox-container link-mark mb-0 flex w-[16px] items-center">
                                    <input
                                      className="bot-check h-[unset]"
                                      type="checkbox"
                                      checked={selectedAll}
                                      onChange={selectAll}
                                      disabled={isPostTrainingDelay}
                                    />
                                    <span className="mark">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                      >
                                        <rect
                                          width="16"
                                          height="16"
                                          rx="5"
                                          fill="#FB5F66"
                                        />
                                        <path
                                          d="M11.6923 4.11088C11.3794 3.90411 10.9616 3.99489 10.7589 4.31353L6.9773 10.2532L5.13304 8.51563C4.85926 8.25774 4.43251 8.2747 4.17942 8.55368C3.92634 8.83243 3.94298 9.26775 4.21677 9.52541L6.63828 11.8068C6.63828 11.8068 6.70779 11.8677 6.73996 11.8891C6.85334 11.9642 6.98067 12 7.10665 12C7.32757 12 7.54421 11.8895 7.67356 11.6864L11.8912 5.06198C12.0941 4.74334 12.005 4.31742 11.6923 4.11088Z"
                                          fill="white"
                                        />
                                      </svg>
                                    </span>
                                  </label>
                                )}
                                <span className="pl-[16px] font-medium">
                                  File Name
                                </span>
                              </th>
                              <th>Status</th>
                              <th className="flex items-center gap-10">
                                File Type
                              </th>
                              <th className="flex items-center gap-10 whitespace-nowrap">
                                Size
                              </th>
                              <th className="flex items-center gap-10 whitespace-nowrap">
                                Characters
                              </th>
                              <th className="flex items-center gap-10">
                                Last Updated
                              </th>

                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody
                            className={`grey-scrollbar flex !h-max flex-col items-center justify-start ${rejectedFiles && rejectedFiles.length > 0 ? "err_dynamic_height" : "link-dynamic-height"}`}
                          >
                            {paginatedFiles.length > 0 ? (
                              paginatedFiles?.map((file, index) => {
                                const actualIndex =
                                  (fileCurrentPage - 1) * itemsPerPage + index;
                                return (
                                  <tr
                                    className={`w-100 flex flex-col ${inProcess ? "pointer-events-none opacity-50" : ""}`}
                                    key={actualIndex}
                                  >
                                    <td className="flex items-center">
                                      <label className="checkbox-container link-mark mb-0 flex w-[16px] items-center">
                                        <input
                                          className="bot-check h-[unset]"
                                          type="checkbox"
                                          checked={selectedIds.some(
                                            (item: any) =>
                                              item.title === file.title,
                                          )}
                                          onChange={() => toggleSelection(file)}
                                          disabled={
                                            isPostTrainingDelay ||
                                            file.status === "In Progress"
                                          }
                                        />
                                        <span className="mark !w-[18px]">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                          >
                                            <rect
                                              width="16"
                                              height="16"
                                              rx="5"
                                              fill="#FB5F66"
                                            />
                                            <path
                                              d="M11.6923 4.11088C11.3794 3.90411 10.9616 3.99489 10.7589 4.31353L6.9773 10.2532L5.13304 8.51563C4.85926 8.25774 4.43251 8.2747 4.17942 8.55368C3.92634 8.83243 3.94298 9.26775 4.21677 9.52541L6.63828 11.8068C6.63828 11.8068 6.70779 11.8677 6.73996 11.8891C6.85334 11.9642 6.98067 12 7.10665 12C7.32757 12 7.54421 11.8895 7.67356 11.6864L11.8912 5.06198C12.0941 4.74334 12.005 4.31742 11.6923 4.11088Z"
                                              fill="white"
                                            />
                                          </svg>
                                        </span>
                                      </label>
                                      <span
                                        className="fx trainedLinksUrl ml-[16px] gap-8 overflow-hidden whitespace-nowrap"
                                        onMouseEnter={(e) => {
                                          const container = e.currentTarget;
                                          const inner = container.querySelector(
                                            ".scrolling-text",
                                          ) as HTMLElement | null;
                                          if (inner) {
                                            const scrollDistance =
                                              inner.scrollWidth -
                                              container.offsetWidth;
                                            if (scrollDistance > 0) {
                                              // Set a fixed speed of 100 pixels per second
                                              const speed = 100; // pixels per second
                                              const duration =
                                                scrollDistance / speed;
                                              inner.style.transition = `transform ${duration}s linear`;
                                              inner.style.transform = `translateX(-${scrollDistance}px)`;
                                            }
                                          }
                                        }}
                                        onMouseLeave={(e) => {
                                          const container = e.currentTarget;
                                          const inner = container.querySelector(
                                            ".scrolling-text",
                                          ) as HTMLElement | null;
                                          if (inner) {
                                            inner.style.transition =
                                              "transform 0.3s ease-out";
                                            inner.style.transform =
                                              "translateX(0)";
                                          }
                                        }}
                                      >
                                        <div className="scrolling-text flex items-center gap-2 whitespace-nowrap">
                                          <span>
                                            {" "}
                                            {file?.title || file?.name}
                                          </span>
                                        </div>
                                      </span>
                                    </td>
                                    <td
                                      className={`flex items-center gap-[6px] whitespace-nowrap ${file?.status === "In Progress" && "rotating-svg"} ${file?.status === "Re-syncing" && "resyncing-svg"}`}
                                    >
                                      {
                                        statuses.find(
                                          (item) => item.text === file.status,
                                        )?.iconComponent
                                      }
                                      {file.status}
                                    </td>

                                    <td>
                                      {renderFileType(
                                        file?.title || file?.name,
                                      )}
                                    </td>
                                    <td>
                                      {file?.size / (1024 * 1024) >= 0.01
                                        ? (file?.size / (1024 * 1024)).toFixed(
                                            2,
                                          ) + " MB"
                                        : (file?.size / 1024).toFixed(2) +
                                          " KB"}
                                    </td>

                                    <td
                                      className={`flex items-center gap-[6px] whitespace-nowrap ${file?.status === "In Progress" && "rotating-svg"} ${file?.status === "Re-syncing" && "resyncing-svg"}`}
                                    >
                                      {
                                        statuses.find(
                                          (item) => item.text === file.status,
                                        )?.iconComponent
                                      }
                                      {file.status == "Training Complete"
                                        ? useFormatNumber(file?.characterCount)
                                        : file.status == "File Rejected"
                                          ? "Failed"
                                          : "Syncing"}
                                    </td>
                                    <td>
                                      {isNaN(Number(file.lastSyncTime)) ||
                                      !file.lastSyncTime
                                        ? "..."
                                        : moment(
                                            Number(file.lastSyncTime),
                                          ).fromNow()}
                                    </td>
                                    <td
                                      className="files_action_drp relative flex items-center justify-center"
                                      onMouseLeave={() =>
                                        handleDropdowns(
                                          index,
                                          "fileAction",
                                          false,
                                        )
                                      }
                                    >
                                      <svg
                                        className="cursor-pointer"
                                        ref={(el) => {
                                          if (!dropdownRef.current)
                                            dropdownRef.current = {};
                                          dropdownRef.current[
                                            `fileAction-${index}`
                                          ] = el;
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDropdowns(
                                            index,
                                            "fileAction",
                                            !dropdowns[index]?.fileAction,
                                          );
                                        }}
                                        width={17}
                                        height={16}
                                        viewBox="0 0 17 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clipPath="url(#clip0_190_17855)">
                                          <path
                                            d="M8.49966 3.33331C9.42013 3.33331 10.1663 2.58713 10.1663 1.66666C10.1663 0.746187 9.42013 0 8.49966 0C7.5792 0 6.83301 0.746187 6.83301 1.66666C6.83301 2.58713 7.5792 3.33331 8.49966 3.33331Z"
                                            fill="#444444"
                                          />
                                          <path
                                            d="M8.49966 9.66632C9.42013 9.66632 10.1663 8.92013 10.1663 7.99966C10.1663 7.0792 9.42013 6.33301 8.49966 6.33301C7.5792 6.33301 6.83301 7.0792 6.83301 7.99966C6.83301 8.92013 7.5792 9.66632 8.49966 9.66632Z"
                                            fill="#444444"
                                          />
                                          <path
                                            d="M8.49966 16.0003C9.42013 16.0003 10.1663 15.2541 10.1663 14.3336C10.1663 13.4142 9.32541 12.668 8.40494 12.668C7.48447 12.668 6.73828 13.4142 6.73828 14.3336C6.73828 15.2541 7.48447 16.0003 8.40494 16.0003Z"
                                            fill="#444444"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_190_17855">
                                            <rect
                                              width={16}
                                              height={16}
                                              fill="white"
                                              transform="translate(0.5)"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      {dropdowns[index]?.fileAction &&
                                        createPortal(
                                          <ul
                                            id={`dropdown-fileAction-${index}`}
                                            className={`status_dropdown_list absolute z-10 !w-[150px] overflow-hidden rounded-[8px]`}
                                            style={{
                                              top: `${dropdownPosition.top}px`,
                                              left: `${dropdownPosition.left}px`,
                                              zIndex: 999,
                                              ...(fromOutgrow && {
                                                fontFamily:
                                                  '"Ubuntu", sans-serif',
                                              }),
                                            }}
                                          >
                                            <li
                                              // className="flex cursor-pointer items-center gap-[6px]"
                                              className={`flex cursor-pointer items-center gap-[6px] ${file?.status === "In Progress" ? "pointer-events-none opacity-50" : ""}`}
                                              onClick={() => {
                                                handleViewDetails(
                                                  file.title,
                                                  file.status,
                                                  "",
                                                  index,
                                                  "file",
                                                );
                                                handleDropdowns(
                                                  index,
                                                  "fileAction",
                                                  false,
                                                );
                                              }}
                                            >
                                              <ViewDetailsIcon />
                                              View Details
                                            </li>
                                            <li
                                              className={`flex cursor-pointer items-center gap-[6px] ${file?.status === "In Progress" ? "pointer-events-none opacity-50" : ""}`}
                                              onClick={() => {
                                                if (
                                                  file.status === "In Progress"
                                                )
                                                  return;
                                                handleFileRemove(
                                                  deleteTrainDocument,

                                                  {
                                                    source: file,
                                                    size: file.size,
                                                    sourceType: "documents",
                                                    fileId: file.id,
                                                  },
                                                );
                                                handleDropdowns(
                                                  index,
                                                  "fileAction",
                                                  false,
                                                );
                                              }}
                                            >
                                              <DelIconSvg />
                                              Delete
                                            </li>
                                          </ul>,
                                          document.getElementById(
                                            "dropdown-portal",
                                          ) as HTMLElement,
                                        )}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <div className="no_links_fetched pd-30 h-100 grid place-items-center">
                                <img
                                  src="https://dlvkyia8i4zmz.cloudfront.net/7eUKmJsvR0OTNIC4DKVQ_1.svg"
                                  alt="no links fetched"
                                />
                              </div>
                            )}
                          </tbody>
                        </table>
                        <div className="border-t-[rgba(0, 0, 0, 0.10)] flex h-[60px] w-full items-center justify-between overflow-hidden rounded-b-[10px] border-t bg-[#f9f9f9] px-[30px] py-[16px]">
                          <Pagination
                            currentPage={fileCurrentPage}
                            totalPages={Math.ceil(
                              searchedFiles.length / itemsPerPage,
                            )}
                            totalItems={searchedFiles.length}
                            itemsPerPage={itemsPerPage}
                            onPageChange={handleFilePageChange}
                            showFirstLast={true}
                            showItemsInfo={true}
                          />
                        </div>
                      </>
                    ) : (
                      <div className="no_links_fetched pd-30 h-100 grid place-items-center">
                        <img
                          src="https://dlvkyia8i4zmz.cloudfront.net/7eUKmJsvR0OTNIC4DKVQ_1.svg"
                          alt="no links fetched"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </motion.div>
          )}
          {selectedSourceTab == "text" && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
              className="h-full"
            >
              <TextAreaComponent
                selectedSourceTab={selectedSourceTab}
                textContentId={botData.aiSource?.textArea?.contentId}
                characterUsed={characterUsed}
                characterLimit={characterLimit}
                allTrained={false}
                onDataChange={onDataChange}
                isOld={isOld}
              />
            </motion.div>
          )}
          {selectedSourceTab == "trained_files" && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
              className="fx-d-col h-100 flex gap-[20px] overflow-auto pb-20"
            >
              <h3 className="flex items-center gap-[10px] border-b border-b-[rgba(0,0,0,0.1)] pb-[16px]">
                All Trained Files
                {isOld && (
                  <div className="character-count-wrapper flex items-center gap-[10px]">
                    <span className="!ms-[0px] h-[24px] w-[1px] bg-[#666] opacity-[0.3]"></span>
                    <p
                      className={`character-count pointer relative z-[5] flex items-center gap-[4px] rounded-[5px] px-[8px] py-[6px] text-[13px] font-medium capitalize leading-normal ${useFormatNumber(characterUsed) === useFormatNumber(characterLimit) ? "bg-[#FFE8E9] text-[#fb5f66]" : "bg-[#FEF2CC] text-[#9A6815]"} `}
                    >
                      <CharacterLimitIcon
                        color={
                          useFormatNumber(characterUsed) ===
                          useFormatNumber(characterLimit)
                            ? "#fb5f66"
                            : "#9A6815"
                        }
                      />
                      {characterLimit === 0 ? (
                        <div className="yellow-loader"></div>
                      ) : (
                        `${useFormatNumber(characterUsed)} / ${useFormatNumber(characterLimit)}`
                      )}
                      <div className="none absolute left-[0] top-[35px] z-[1] w-[280px] cursor-default flex-col items-center gap-[10px] rounded-[8px] bg-[#222] p-[10px]">
                        {useFormatNumber(characterUsed) ===
                        useFormatNumber(characterLimit) ? (
                          <p className="text-center text-[12px] font-normal normal-case not-italic leading-[17px] text-[#fb5f66]">
                            Your current plan doesn't support more than
                            <b className="font-medium">
                              {useFormatNumber(characterLimit)} Characters.
                            </b>
                            {plan.name !== "Professional"
                              ? "Upgrade to the Professional plan to unlock this feature."
                              : "If you want more, you have to buy the add-on."}
                          </p>
                        ) : (
                          <p className="text-center text-[12px] font-normal normal-case not-italic leading-[17px] text-white/80">
                            Agents can use a maximum of <br />
                            <b className="font-medium">
                              {useFormatNumber(characterLimit)} Characters
                            </b>
                            , including link content. Anything over that limit
                            won't be used.
                          </p>
                        )}
                        {plan.name !== "Professional" ? (
                          <button
                            className="pointer h-[30px] w-full rounded-[8px] bg-[#fb5f66] text-[12px] font-normal leading-normal text-white"
                            onClick={() => {
                              setBuyAddOn(false);
                              setLeaveModal(true);
                            }}
                          >
                            Upgrade Plan
                          </button>
                        ) : (
                          <button
                            className="pointer h-[30px] w-full rounded-[8px] bg-[#fb5f66] text-[12px] font-normal leading-normal text-white"
                            onClick={() => {
                              setBuyAddOn(true);
                              setLeaveModal(true);
                            }}
                          >
                            Buy add-on
                          </button>
                        )}
                      </div>
                    </p>
                  </div>
                )}
              </h3>
              <AllTrainedFiles
                botData={botData}
                trainedFiles={trainedFiles}
                setSelectedSourceTab={setSelectedSourceTab}
                selectedSourceTab={selectedSourceTab}
                characterUsed={characterUsed}
                characterLimit={characterLimit}
                isOld={isOld}
              />
            </motion.div>
          )}

          {removeData.status && (
            <ModalWrapper>
              <RemoveConfirmation
                removeData={removeData}
                setRemoveData={setRemoveData}
                isLoading={isDeleting}
              />
            </ModalWrapper>
          )}
          {viewDetailsModal && (
            <ModalWrapper>
              <ViewDetailsModal
                onClose={() => setViewDetailsModal(false)}
                url={selectedUrl}
                content={selectedContent}
                isLoading={viewDetailsLoading}
              />
            </ModalWrapper>
          )}
          {leaveModal && (
            <ModalWrapper>
              <BooleanModal
                onConfirm={() => {
                  navigate("/settings");
                  buyAddOn
                    ? dispatch(userSlice.actions.setSettings(6))
                    : dispatch(userSlice.actions.setSettings(2));
                }}
                onCancel={() => setLeaveModal(false)}
              />
            </ModalWrapper>
          )}
        </div>
      )}
      {selectedSourceTab == "updated_bot_qa" && (
        <AllQuestionsModal
          selectedBot={botData}
          hideFilters={true}
          onClose={() => setSelectedSourceTab("")}
        />
      )}
    </>
  );
}

export default AIBotTab_1;

export const statuses = [
  { text: "All Statuses" },
  {
    iconComponent: <TrainingCompletedIcon />,
    text: "Training Complete",
  },
  {
    iconComponent: <TrainingProgressIcon />,
    text: "In Progress",
  },
  {
    iconComponent: <LinkRejectedIcon />,
    text: "Link Rejected",
  },
  {
    iconComponent: <LinkRejectedIcon />,
    text: "Limit Reached",
  },
  {
    iconComponent: <LinkRejectedIcon />,
    text: "File Rejected",
  },
  {
    iconComponent: <ReSyncingIcon />,
    text: "Re-syncing",
  },
  {
    iconComponent: <TrainingCompletedIcon />,
    text: "Re-sync Complete",
  },
  {
    iconComponent: <ReSyncingFailedIcon />,
    text: "Re-sync Failed",
  },
];

const syncTimeMapping = {
  0: "Off",
  7: "Every week",
  14: "Every 2 weeks",
  28: "Every 4 weeks",
};

const order = [
  {
    text: "Ascending",
    iconComponent: <AscendingOrderSvg />,
  },
  {
    text: "Descending",
    iconComponent: <DescendingOrderSVG />,
  },
];

export const ManageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.4469 9.53301L14.1802 12.8663C14.0802 13.8863 14.0002 14.6663 12.1935 14.6663H3.80684C2.00017 14.6663 1.92017 13.8863 1.82017 12.8663L1.5535 9.53301C1.50017 8.97967 1.6735 8.46634 1.98684 8.07301C1.9935 8.06634 1.9935 8.06634 2.00017 8.05967C2.36684 7.61301 2.92017 7.33301 3.54017 7.33301H12.4602C13.0802 7.33301 13.6269 7.61301 13.9869 8.04634C13.9935 8.05301 14.0002 8.05967 14.0002 8.06634C14.3269 8.45967 14.5069 8.97301 14.4469 9.53301Z"
      stroke="#FB5F66"
      strokeMiterlimit={10}
    />
    <path
      d="M2.3335 7.62018V4.18685C2.3335 1.92018 2.90016 1.35352 5.16683 1.35352H6.0135C6.86014 1.35352 7.05347 1.60685 7.37347 2.03352L8.22014 3.16685C8.43347 3.44685 8.56014 3.62018 9.1268 3.62018H10.8268C13.0935 3.62018 13.6601 4.18685 13.6601 6.45352V7.64685"
      stroke="#FB5F66"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.28674 11.333H9.71342"
      stroke="#FB5F66"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIconSvg = () => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_190_19711)">
      <path
        d="M10.4063 0C8.42844 0 6.49504 0.58649 4.85055 1.6853C3.20606 2.78412 1.92434 4.3459 1.16746 6.17317C0.410583 8.00043 0.212549 10.0111 0.598402 11.9509C0.984254 13.8907 1.93666 15.6725 3.33519 17.0711C4.73371 18.4696 6.51554 19.422 8.45535 19.8079C10.3952 20.1937 12.4058 19.9957 14.2331 19.2388C16.0603 18.4819 17.6221 17.2002 18.7209 15.5557C19.8198 13.9112 20.4063 11.9778 20.4063 10C20.4034 7.34872 19.3489 4.80684 17.4742 2.9321C15.5994 1.05736 13.0575 0.00286757 10.4063 0ZM10.4063 18.3333C8.75808 18.3333 7.14691 17.8446 5.7765 16.9289C4.40609 16.0132 3.33799 14.7117 2.70726 13.189C2.07653 11.6663 1.9115 9.99076 2.23304 8.37425C2.55459 6.75774 3.34826 5.27288 4.5137 4.10744C5.67914 2.94201 7.16399 2.14833 8.7805 1.82679C10.397 1.50525 12.0726 1.67027 13.5953 2.301C15.118 2.93173 16.4195 3.99984 17.3352 5.37025C18.2508 6.74066 18.7396 8.35182 18.7396 10C18.7372 12.2094 17.8584 14.3276 16.2961 15.8899C14.7339 17.4522 12.6156 18.3309 10.4063 18.3333ZM14.5729 10C14.5729 10.221 14.4851 10.433 14.3288 10.5893C14.1726 10.7455 13.9606 10.8333 13.7396 10.8333H11.2396V13.3333C11.2396 13.5543 11.1518 13.7663 10.9955 13.9226C10.8392 14.0789 10.6273 14.1667 10.4063 14.1667C10.1852 14.1667 9.97328 14.0789 9.817 13.9226C9.66072 13.7663 9.57292 13.5543 9.57292 13.3333V10.8333H7.07292C6.85191 10.8333 6.63995 10.7455 6.48367 10.5893C6.32738 10.433 6.23959 10.221 6.23959 10C6.23959 9.77899 6.32738 9.56703 6.48367 9.41074C6.63995 9.25447 6.85191 9.16667 7.07292 9.16667H9.57292V6.66667C9.57292 6.44565 9.66072 6.23369 9.817 6.07741C9.97328 5.92113 10.1852 5.83333 10.4063 5.83333C10.6273 5.83333 10.8392 5.92113 10.9955 6.07741C11.1518 6.23369 11.2396 6.44565 11.2396 6.66667V9.16667H13.7396C13.9606 9.16667 14.1726 9.25447 14.3288 9.41074C14.4851 9.56703 14.5729 9.77899 14.5729 10Z"
        fill="#FB5F66"
      />
    </g>
    <defs>
      <clipPath id="clip0_190_19711">
        <rect
          width={20}
          height={20}
          fill="white"
          transform="translate(0.40625)"
        />
      </clipPath>
    </defs>
  </svg>
);

export function InputField({
  websiteUrl,
  setWebsiteUrl,
  fetchUrl,
  onDataChange,
  searchData,
  isOnboarding = false,
}) {
  const [displayText, setDisplayText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [searchHistory, setSearchHistory] = useState<string[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const placeholders = [
    " website link here...",
    " sitemap link here...",
    " YouTube link here...",
  ];

  // Load search history from localStorage on component mount
  useEffect(() => {
    // const savedHistory = localStorage.getItem("searchLinkHistory");
    const savedHistory = JSON.stringify(searchData);
    // const savedHistory = searchData;
    if (savedHistory) {
      try {
        const parsedHistory = JSON.parse(savedHistory);
        if (Array.isArray(parsedHistory)) {
          setSearchHistory(parsedHistory.slice(0, 5));
        }
      } catch (error) {
        console.error("Failed to parse search history", error);
      }
    }
  }, []);

  // Handle click outside to close dropdown
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        event.target instanceof Node &&
        !dropdownRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   if (websiteUrl) return;

  //   let timeout: NodeJS.Timeout | undefined;
  //   const currentPlaceholder = placeholders[currentIndex];

  //   const animateText = async () => {
  //     // Type forward
  //     for (let i = 0; i <= currentPlaceholder.length; i++) {
  //       setDisplayText(currentPlaceholder.substring(0, i));
  //       await new Promise((resolve) => (timeout = setTimeout(resolve, 60)));
  //     }
  //     await new Promise((resolve) => (timeout = setTimeout(resolve, 1000)));

  //     for (let i = currentPlaceholder.length; i >= 0; i--) {
  //       setDisplayText(currentPlaceholder.substring(0, i));
  //       await new Promise((resolve) => (timeout = setTimeout(resolve, 40)));
  //     }
  //     setCurrentIndex((currentIndex + 1) % placeholders.length);
  //   };

  //   animateText();

  //   return () => {
  //     if (timeout) clearTimeout(timeout);
  //   };
  // }, [websiteUrl, currentIndex]);

  // Save search to history when fetchUrl is called
  const handleFetchUrl = () => {
    if (!websiteUrl.trim()) return;

    if (websiteUrl !== searchHistory[0]) {
      const newHistory = [
        websiteUrl,
        ...searchHistory.filter((url) => url !== websiteUrl),
      ].slice(0, 5);
      setSearchHistory(newHistory);
      if (onDataChange) {
        onDataChange("searchLinkHistory", newHistory);
      }
      // localStorage.setItem("searchLinkHistory", JSON.stringify(newHistory));
    }

    if (!isOnboarding) fetchUrl();
    setShowDropdown(false);
  };

  const selectFromHistory = (url: string) => {
    setWebsiteUrl(url);
    setShowDropdown(false);
  };

  return (
    <div
      className="source_link_input_wrapper relative w-full"
      onMouseLeave={() => setShowDropdown(false)}
    >
      <input
        type="text"
        autoFocus
        className={
          isOnboarding
            ? "rounded-[10px] border border-black/10 bg-white p-[15px]"
            : `source_link_input rounded-[12px] bg-[#f8f8f8]`
        }
        value={websiteUrl}
        placeholder="Add website, youtube, sitemap link here "
        onChange={(event) => setWebsiteUrl(event.target.value)}
        onKeyDown={(event) => event.key === "Enter" && handleFetchUrl()}
        onFocus={() => searchHistory.length > 0 && setShowDropdown(true)}
        onClick={() => searchHistory.length > 0 && setShowDropdown(true)}
        // onBlur={() => setShowDropdown(false)}

        ref={inputRef}
      />

      {/* {!websiteUrl && (
        <div className="pointer-events-none absolute left-3 top-1/2 flex -translate-y-1/2 items-center text-gray-400">
          <span>Add {displayText}</span>
          <motion.span
            className="ml-[1px] inline-block h-[18px] w-[2px] bg-gray-500"
            animate={{ opacity: [1, 0] }}
            transition={{
              repeat: Number.POSITIVE_INFINITY,
              repeatType: "reverse",
              duration: 0.8,
              ease: "easeInOut",
            }}
          />
        </div>
      )} */}

      {showDropdown && searchHistory.length > 0 && (
        <div
          className="fetch-input-dd absolute z-[3]"
          ref={dropdownRef}
          onMouseLeave={() => setShowDropdown(false)}
        >
          <ul className="fx fx-d-col">
            {searchHistory.map((url, index) => (
              <li
                key={index}
                className="cursor-pointer text-[14px] text-[#444]"
                onClick={() => selectFromHistory(url)}
              >
                {url}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
